import React, { Component } from 'react';
import {
    GET_IDEA_URL, REVIEW_IDEA_URL, GET_METADATA, ACCESS_TOKEN, USER_DATA, PPT_CONTENT, YESORNO, IMPACTOPTIONS, MONETIZATIONOPTIONS,
    IMPACT_TO_CLIENT
    , IMPACT_TO_GENPACT, NO_VD,
    VD_TO_CLIENT,
    VD_TO_GENPACT,
    VD_TO_CLIENT_PLUS_GENPACT, SIGNOFF_CONTENT,PRODUCTIVITY_PROJECTS_UPDATE_URL
} from '../assets/constants/constants';
import Toast from 'light-toast';
import Select from 'react-select';


let showMBBWarningOnce = 0;

export class ValueDelivery extends Component {

    sessionData = JSON.parse(localStorage.getItem(USER_DATA));
    accessToken = localStorage.getItem(ACCESS_TOKEN);

    constructor(props) {
        super(props);
        if (this.sessionData === null) {
            Toast.loading("This component cannot be accessed directly. Redirecting to application home.", 3000, () => {
            });
            window.location = "/login";
            return;
        }

        this.state = {
            // vd states
            impactOptionSelected: null,
            finalImpactDollar: "",
            finalImpactFTE: "",

            businessImpactMasterList: [],
            businessImpactValueArray: [],

            filteredImpactTypeState: null,
            filteredBISubCategoryState: [],
            filteredBISubCategorySelectedOption: [],

            filteredImpactTypeSelectedOption: [],
            filteredMonetizableTypeState: [],
            filteredMonetizableSelectedOption: [],

            
            mbbLimit:50000,
            summaryArray: [],

            totalMonetizedFTE: 0,
            totalMonetizedDollar: 0,


            // qc states
            monetizableCheckbox: false,
            appropriateAttachment: false,

            IdeaIDAlpha: 0,
            LeanId: 0,
            CertificationLevelName: "",
            IsFpnaRequired: false,
            ideaCreatedDate: "",

            // state variables from FPNAGOL 

            // client states
            showClientFields: false,
            clientName: "",
            clientRole: "",
            clientSignOffDate: "",

            // gol states
            showGOLFields: false,
            golOhr: "",
            GOLName: "",
            fpnaOhr: "",
            fpnaName: "",

            // monetization states
            GOLOHRMonetization: "",
            GOLNameMonetization: "",

            FPnANameMonetization: '',
            FPnAOHRMonetization: '',
            SowID: "",

            showClientApprovalFields: false,
            monetizationStatusSelectedOption: null,
            monetizableStatus: [],
            monetizableProjectSelectedOption: null,

            // monetization file states
            FPnAFileNameMonetization: '',
            FPnAFileTypeMonetization: '',

            monetizableFieldDisabled: false,
            displayMonetizedWarning: false,
            monetizedAlertCounter: 0,


            // project presentation deck filename
            filename1: "",
            fileType1: "",
            base64File1: "",

            // signoff filename
            filename2: "",
            fileType2: "",
            base64File2: "",

            // gol file
            filename3: "",
            base64File3: "",
            fileType3: "",


            // fpna file
            filename4: "",
            fileType4: "",
            base64File4: "",

            replaceFpnaDoc: false,

            myObj: [
                {
                    id: 0,
                    label: ""
                },
                {
                    id: 1,
                    label: ""
                }
            ],

        }
    }

    async componentDidMount() {
        //await this.fetchIdea();
        if (this.props.BIMasterDataVerseNew) {

            let local_businessImpactMasterList = this.props.BIMasterDataVerseNew;
            this.setState({ businessImpactMasterList: local_businessImpactMasterList }, () => { })

            let filteredImpactType = local_businessImpactMasterList.map(item => item.pg_impacttype).filter(
                (value, index, self) => self.indexOf(value) === index
            )
            filteredImpactType = Object.entries(filteredImpactType)
            this.setState({ filteredImpactTypeState: filteredImpactType }, () => { })

            let filtereedMonetizabletype = local_businessImpactMasterList.map(item => item.pg_monetizabletype).filter(
                (value, index, self) => self.indexOf(value) === index
            )
            filtereedMonetizabletype = Object.entries(filtereedMonetizabletype)
            this.setState({ filteredMonetizableTypeState: filtereedMonetizabletype }, () => { })

            let filteredBiSubCategory = local_businessImpactMasterList.map(item => item.pg_bisubcategory).filter(
                (value, index, self) => self.indexOf(value) === index
            )
            filteredBiSubCategory = Object.entries(filteredBiSubCategory)
            this.setState({ filteredBISubCategoryState: filteredBiSubCategory }, () => { })
        }




        if (this.props.IdeaData) {
            let tableData = null;
            tableData = this.props.IdeaData ? this.props.IdeaData : []
            this.setState({
                LeanId: tableData.LeanID,
                IdeaIDAlpha: tableData.IdeaIDAlpha,
                finalImpactDollar: tableData.FinalImpactDollar,
                finalImpactFTE: tableData.FinalImpactFTE,
                CertificationLevelName: tableData.CertificationLevelName,
            }, () => { })


            if (tableData.VDType) {
                IMPACTOPTIONS.map((item) => {
                    if (tableData.VDType === item.label) {
                        this.setState({ impactOptionSelected: item }, () => { })
                        this.props.vdType(item)
                    }
                })

                if (tableData.VDType === NO_VD) {
                    this.setState({ showClientFields: false, showGOLFields: false, }, () => { })
                }
                if (tableData.VDType === VD_TO_CLIENT) {
                    this.setState({ showClientFields: true, showGOLFields: true, }, () => { })
                }
                if (tableData.VDType === VD_TO_GENPACT) {
                    this.setState({ showClientFields: false, showGOLFields: true, }, () => { })
                }
                if (tableData.VDType === VD_TO_CLIENT_PLUS_GENPACT) {
                    this.setState({ showClientFields: true, showGOLFields: true, }, () => { })
                }

            }
            if (tableData.IsVDMonetizable) {
                YESORNO.map((item) => {
                    if (tableData.IsVDMonetizable === item.label) {
                        this.setState({ monetizableProjectSelectedOption: item, monetizableStatus: item }, () => { })
                        this.props.monetizableProject(item)
                    }
                    if (tableData.IsVDMonetizable === "Yes") {
                        this.setState({ monetizableFieldDisabled: true }, () => { })
                    }
                    if (tableData.IsVDMonetizable === "No") {
                        this.setState({
                            monetizationStatusSelectedOption: [],
                            showClientApprovalFields: false,
                            FPnAFileNameMonetization: "",
                            SowID: ""
                        }, () => { })
                    }
                })
            }
            if (tableData.MonetizationStatus) {
                MONETIZATIONOPTIONS.map((item) => {
                    if (tableData.MonetizationStatus === item.label) {
                        this.setState({ monetizationStatusSelectedOption: item }, () => { })
                        this.props.monetizableStatus(item)


                        if (item.label === "Approved by Client") {
                            this.setState({ showClientApprovalFields: true })
                        } else {
                            this.setState({
                                showClientApprovalFields: false,
                                FPnAFileNameMonetization: "",
                                SowID: ""

                            })
                        }
                    }
                })
            }

            if (tableData.GOLNameMonetization) {
                let localGOLMonetizationName = tableData.GOLNameMonetization;
                this.setState({ GOLNameMonetization: localGOLMonetizationName }, () => { })
                this.props.fetchMonetizationGOLName(localGOLMonetizationName)
            } else {
                let localGOLMonetizationName = tableData.GOLName;
                this.setState({ GOLNameMonetization: localGOLMonetizationName }, () => { })
                this.props.fetchMonetizationGOLName(localGOLMonetizationName)
            }

            if (tableData.GOLOHRMonetization) {
                let localGOLMonetizationOhr = tableData.GOLOHRMonetization
                this.setState({ GOLOHRMonetization: localGOLMonetizationOhr }, () => { })
                this.props.fetchMonetizationGOLOhr(localGOLMonetizationOhr)
            } else {
                let localGOLMonetizationOhr = tableData.GOLOHR
                this.setState({ GOLOHRMonetization: localGOLMonetizationOhr }, () => { })
                this.props.fetchMonetizationGOLOhr(localGOLMonetizationOhr)
            }

            if (tableData.GOLOHR) {
                let localGOLOhr = tableData.GOLOHR
                this.setState({ golOhr: localGOLOhr }, () => { })
                this.props.fetchGolOhr(localGOLOhr)
            }
            if (tableData.GOLName) {
                let localgolname = tableData.GOLName
                this.setState({ GOLName: localgolname }, () => { })
                this.props.fetchGolName(localgolname)
            }

            if (tableData.FPnANameMonetization) {
                let localFpnaNameMonetization = tableData.FPnANameMonetization
                this.setState({ FPnANameMonetization: localFpnaNameMonetization }, () => { })
                this.props.fetchMonetizationFpnaName(localFpnaNameMonetization)
            } else {
                let localFpnaNameMonetization = tableData.FPnAName
                this.setState({ FPnANameMonetization: localFpnaNameMonetization }, () => { })
                this.props.fetchMonetizationFpnaName(localFpnaNameMonetization)

            }
            if (tableData.FPnAFileNameMonetization) {
                let localFpnaNameFileNameMonetization = tableData.FPnAFileNameMonetization
                this.setState({ FPnAFileNameMonetization: localFpnaNameFileNameMonetization }, () => { })
            }

            if (tableData.FPnAOHR) {
                let localfpnaOhr = tableData.FPnAOHR;
                this.setState({ fpnaOhr: localfpnaOhr }, () => { })
                this.props.fetchFpnaOhr(localfpnaOhr)
            }
            if (tableData.FPnAName) {
                let localfpnaname = tableData.FPnAName
                this.setState({ fpnaName: localfpnaname }, () => { })
                this.props.fetchFpnaName(localfpnaname)
            }

            if (tableData.FPnAOHRMonetization) {
                let localFPnAOHRMonetization = tableData.FPnAOHRMonetization
                this.props.fetchMonetizationFpnaOhr(localFPnAOHRMonetization)
                this.setState({ FPnAOHRMonetization: localFPnAOHRMonetization }, () => { })

            } else {
                let localFPnAOHRMonetization = tableData.FPnAOHR
                this.setState({ FPnAOHRMonetization: localFPnAOHRMonetization }, () => { })
                this.props.fetchMonetizationFpnaOhr(localFPnAOHRMonetization)
            }
            if (tableData.SowID) {
                let localSowIdhere = tableData.SowID
                this.props.fetchMonetizationSowID(localSowIdhere)
                this.setState({ SowID: localSowIdhere }, () => { })
            }


            if (tableData.CustName) {
                let localClientName = tableData.CustName;
                this.props.fetchClientName(localClientName)
                this.setState({ clientName: localClientName }, () => { })
            }
            if (tableData.CustDesgn) {
                let localClientDesignation = tableData.CustDesgn;
                this.props.fetchClientRole(localClientDesignation)
                this.setState({ clientRole: localClientDesignation }, () => { })
            }
            if (tableData.CustSignOffDate) {
                let localClientSignOffDate = new Date(tableData.CustSignOffDate).toLocaleDateString('en-CA').split('/').reverse().join('-');
                this.setState({ clientSignOffDate: localClientSignOffDate }, () => { })
                this.props.fetchClientSignOffDate(localClientSignOffDate)

            }
            if (tableData.ProjectPPTFileName) {
                let localfileName1 = tableData.ProjectPPTFileName;
                let localfileType1 = tableData.ProjectPPTType
                this.setState({
                    filename1: localfileName1,
                    fileType1: localfileType1
                }, () => { })
                this.props.fetchPPTDeck(localfileName1, localfileType1, "")
            }


            if (tableData.CustomerSignoffFileName) {
                let localfileName2 = tableData.CustomerSignoffFileName;
                let localfileType2 = tableData.CustomerSignoffType;
                this.setState({ filename2: localfileName2, fileType2: localfileType2 }, () => { })
                this.props.fetchClientDocName(localfileName2)
                this.props.fetchClientDocType(localfileType2)
            }


            if (tableData.GOLFileName) {
                let localfileName3 = tableData.GOLFileName;
                let localfileType3 = tableData.GOLFileType;
                this.setState({
                    filename3: localfileName3,
                    fileType3: localfileType3
                }, () => { })
                this.props.fetchGolDocName(localfileName3)
                this.props.fetchGolDocType(localfileType3)

            }

            if (tableData.FPnAFileName) {
                let localfileName4 = tableData.FPnAFileName;
                let localfileType4 = tableData.FPnAFileType;
                this.setState({
                    filename4: localfileName4,
                    fileType4: localfileType4
                }, () => { })
                this.props.fetchfpnaDocName(localfileName4)
                this.props.fetchfpnaDocType(localfileType4)
            }
            if (tableData.CreatedDate) {
                let createdDate = new Date(tableData.CreatedDate);
                let convertedDate = createdDate.toLocaleDateString();
                this.setState({ ideaCreatedDate: convertedDate })
            }

            let localabc = tableData.GOLFileName === null || tableData.GOLFileName === undefined ? "" : tableData.GOLFileName;
            let localxyz = tableData.FPnAFileName === null || tableData.FPnAFileName === undefined ? "" : tableData.FPnAFileName;

            const selectedOption = [
                {
                    id: 0,
                    label: localabc
                }
                ,
                {
                    id: 1,
                    label: localxyz
                }
            ];
            this.setState({ myObj: selectedOption }, () => {
                this.props.fetchFileDetails(this.state.myObj)
            })


            if (this.props.vdForComponent) {
                let localBIData = this.props.vdForComponent;
                localBIData.sort((a, b) => a.ImpactType.localeCompare(b.ImpactType))

                let local_isfpnarequired = false;
                localBIData && localBIData.map((item) => {
                    if (item.ImpactType === IMPACT_TO_GENPACT) {
                        if (item.MonetizableType === "Increase in Revenue" || item.MonetizableType === "Reduction in Cost") {
                            local_isfpnarequired = true;
                        }
                    }
                    if (item.MonetizableType && item.MonetizableType === "Productivity") {
                        local_isfpnarequired = true;
                    }
                })
                this.setState({ IsFpnaRequired: local_isfpnarequired, businessImpactValueArray: localBIData }, () => {
                    this.newBusinessImpactSummary()
                })
            }
        }
    };

    handleMonetizableProjectChange = (e) => {
        this.setState({monetizationStatusSelectedOption: []},()=>{})
        this.props.monetizableProject(e)
        this.props.monetizableStatus([])
        this.setState({ monetizableProjectSelectedOption: e})
    }
    handleMonetizableStatusChange = (e) => {
        this.props.monetizableStatus(e)
        this.newBusinessImpactSummary()
        this.setState({
            monetizationStatusSelectedOption: e,
            filteredImpactTypeSelectedOption: [],
            filteredMonetizableSelectedOption: [],
            filteredBISubCategorySelectedOption: [],
            SowID:""
        })
        if (e && e.label === "Approved by Client") {
            this.props.fetchMonetizationFpnaName(this.state.FPnANameMonetization)
            this.props.fetchMonetizationFpnaOhr(this.state.FPnAOHRMonetization)
            this.props.fetchMonetizationGOLName(this.state.GOLNameMonetization)
            this.props.fetchMonetizationGOLOhr(this.state.GOLOHRMonetization)
            this.props.fetchMonetizationSowID(this.state.SowID)
        }
    }
    renderFilteredImpactType = (e) => {
        let options = [];
        if (this.state.impactOptionSelected) {
            if (this.state.impactOptionSelected.label === VD_TO_CLIENT_PLUS_GENPACT) {
                if (this.props.bbMonetizationApproval) {
                    this.state.filteredImpactTypeState && this.state.filteredImpactTypeState.slice(-1).map((item) => {
                        options.push({
                            value: item[0],
                            label: item[1]
                        })
                        return options;
                    });
                } else {
                    this.state.filteredImpactTypeState && this.state.filteredImpactTypeState.map((item) => {
                        options.push({
                            value: item[0],
                            label: item[1]
                        })
                        return options;
                    });
                }

            }
            if (this.state.impactOptionSelected.label === VD_TO_GENPACT) {
                this.state.filteredImpactTypeState && this.state.filteredImpactTypeState.slice(-1).map((item) => {
                    options.push({
                        value: item[0],
                        label: item[1]
                    })
                    return options;
                });
            }
            if (this.state.impactOptionSelected.label === VD_TO_CLIENT) {
                this.state.filteredImpactTypeState && this.state.filteredImpactTypeState.slice(0, 1).map((item) => {
                    options.push({
                        value: item[0],
                        label: item[1]
                    })
                    return options;
                });
            }

        }
        
        return options;

    }
    handleImpactTypeChange = (e) => {
        this.setState({
            filteredImpactTypeSelectedOption: e,
            filteredMonetizableSelectedOption: [],
            filteredBISubCategorySelectedOption: [],
        })
    }

    renderFilteredMonetizableType = (e) => {
        let options = [];
        if (this.state.filteredImpactTypeSelectedOption) {
            if (this.props.bbMonetizationApproval) {
                options.push({
                    value: 0,
                    label: "Increase in Revenue"
                })
            } else {
                this.state.filteredMonetizableTypeState?.map((item) => {
                    options.push({
                        value: item[0],
                        label: item[1]
                    })
                });
            }
        }
        return options;
    }

    handleMonetizableTypeChange = (e) => {
        if (e !== null || e !== undefined) {
            const selectedOption = {
                value: e.value,
                label: e.label
            };
            this.setState({ filteredMonetizableSelectedOption: selectedOption, filteredBISubCategorySelectedOption: [] }, () => { })
        }

    }

    renderFilteredBiSubCategoryType = (e) => {
        let options = [];
        if (this.props.bbMonetizationApproval) {
            this.state.businessImpactMasterList && this.state.businessImpactMasterList.forEach((item, index) => {
                if (
                    this.state.filteredImpactTypeSelectedOption &&
                    this.state.filteredMonetizableSelectedOption &&
                    item.pg_impacttype === this.state.filteredImpactTypeSelectedOption.label &&
                    item.pg_monetizabletype === "Increase in Revenue"
                ) {
                    options.push({
                        value: index,
                        label: item.pg_bisubcategory
                    });

                }
            });
            return options;
        } else {
            this.state.businessImpactMasterList && this.state.businessImpactMasterList.forEach((item, index) => {
                if (
                    this.state.filteredImpactTypeSelectedOption &&
                    this.state.filteredMonetizableSelectedOption &&
                    item.pg_impacttype === this.state.filteredImpactTypeSelectedOption.label &&
                    item.pg_monetizabletype === this.state.filteredMonetizableSelectedOption.label
                ) {
                    options.push({
                        value: index,
                        label: item.pg_bisubcategory
                    });

                }
            });
        }
        return options;
    }



    handleBiSubCategoryChange = (e) => {
        if (e) {
            this.setState({ filteredBISubCategorySelectedOption: e }, () => { })
        }
    }


    addSelectedValues = (e, monetizedAlertCounter) => {
        let ftemin = null;
        let ftemax = null;
        let pvalid = '';

        let myBIMasterList = this.state.businessImpactMasterList  && this.state.businessImpactMasterList;
        for (const pg_item of myBIMasterList) {
            if (this.state.filteredImpactTypeSelectedOption?.label === pg_item.pg_impacttype && this.state.filteredMonetizableSelectedOption?.label === pg_item.pg_monetizabletype && this.state.filteredBISubCategorySelectedOption?.label === pg_item.pg_bisubcategory) {
                ftemin = pg_item.pg_ftemin ? parseFloat(pg_item.pg_ftemin) : "";
                ftemax = pg_item.pg_ftemax ? parseFloat(pg_item.pg_ftemax) : "";
                pvalid = pg_item.pg_isohruploaded
            }
        }
       
        if (this.state.filteredBISubCategorySelectedOption) {
            if (this.state.filteredBISubCategorySelectedOption.label !== "Category Not Listed") {
            
                if (this.state.filteredImpactTypeSelectedOption && this.state.filteredMonetizableSelectedOption && this.state.filteredBISubCategorySelectedOption) {
                    this.state.businessImpactMasterList && this.state.businessImpactMasterList.map((item) => {
                        if (item.pg_impacttype === this.state.filteredImpactTypeSelectedOption.label && item.pg_monetizabletype === this.state.filteredMonetizableSelectedOption.label && item.pg_bisubcategory === this.state.filteredBISubCategorySelectedOption.label) {
                            //console.log("6")
                            let obj = {};
                            let monetized = "";
                            if(this.props.bbMonetizationApproval){
                                monetized="Yes"
                            }
                            if (item.pg_impacttype === IMPACT_TO_GENPACT && (item.pg_monetizabletype === "Increase in Revenue") || (item.pg_bisubcategory === "FTE Equivalent - Improvement in Transaction Based Billing" || item.pg_bisubcategory === "FTE Equivalent - Increase in Billable Hours")){
                                monetized="Yes"
                            }
                            obj = {
                                ImpactType: this.state.filteredImpactTypeSelectedOption.label,
                                MonetizableType: this.state.filteredMonetizableSelectedOption.label,
                                BISubCategory: this.state.filteredBISubCategorySelectedOption.label,
                                SrNo: item.pg_srno,
                                IsMonetized: monetized,
                                PValid: pvalid,
                                FTEMin: ftemin,
                                FTEMax: ftemax
                            }

                            //console.log("obj at add selected values =>",obj)
                            
                            let isDuplicate = this.state.businessImpactValueArray.find(item => item.SrNo === obj.SrNo);
                            if (!isDuplicate) {
                                this.state.businessImpactValueArray.push(obj)
                                //console.log("business impact value array after push =>",this.state.businessImpactValueArray)
                                this.state.businessImpactValueArray.sort((a, b) => a.ImpactType.toLowerCase().localeCompare(b.ImpactType.toLowerCase()))
                                this.newBusinessImpactSummary()
                                this.setState({
                                    filteredImpactTypeSelectedOption: [],
                                    filteredMonetizableSelectedOption: [],
                                    filteredBISubCategorySelectedOption: []
                                }, () => { })
                            }
                            else {
                                window.alert("Same combination of Impact type, Category and Sub category cannot be added again")
                                this.setState({
                                    filteredImpactTypeSelectedOption: [],
                                    filteredMonetizableSelectedOption: [],
                                    filteredBISubCategorySelectedOption: []
                                }, () => { })
                            }
                        }
                        //console.log("6")
                        if (this.state.filteredImpactTypeSelectedOption.label === IMPACT_TO_GENPACT) {
                            if ((this.state.filteredMonetizableSelectedOption.label === "Increase in Revenue" || this.state.filteredMonetizableSelectedOption.label === "Reduction in Cost")) {
                                this.props.fetchFPAOHRforIncreaseInRevenue(true)
                                this.setState({
                                    appropriateAttachment: true,
                                    filteredImpactTypeSelectedOption: [],
                                    filteredMonetizableSelectedOption: [],
                                    filteredBISubCategorySelectedOption: []
                                }, () => { })
                            }
                        }
                    })
                } else {
                    //console.log("7")
                    window.alert("Please Select Impact Type, Category and Sub Category")
                    this.setState({
                        filteredImpactTypeSelectedOption: [],
                        filteredMonetizableSelectedOption: [],
                        filteredBISubCategorySelectedOption: []
                    }, () => { })
                }
            } else {
                //console.log("8")
                this.setState({
                    filteredImpactTypeSelectedOption: [],
                    filteredMonetizableSelectedOption: [],
                    filteredBISubCategorySelectedOption: []
                }, () => { })
                this.props.fetchCategoryNotListed(true)
            }
            this.props.monetizableProject(this.state.monetizableProjectSelectedOption)

            //console.log("9")
            if (this.state.impactOptionSelected && (this.state.impactOptionSelected.label === VD_TO_GENPACT || this.state.impactOptionSelected.label === VD_TO_CLIENT_PLUS_GENPACT)) {
                if (this.state.businessImpactValueArray.some(e => e.IsMonetized === 'Yes')) {
                    if (monetizedAlertCounter === 0) {
                        window.alert("Since you have selected Monetizable category, so this project is selected as Monetized project.");
                        this.setState({ monetizedAlertCounter: monetizedAlertCounter + 1 })
                    }
                } else {
                    this.setState({ monetizedAlertCounter: 0 })
                }
            }

            //console.log("10")

            if (this.state.impactOptionSelected && (this.state.impactOptionSelected.label === VD_TO_GENPACT || this.state.impactOptionSelected.label === VD_TO_CLIENT_PLUS_GENPACT)) {
                let monetizableSelectedDropdown = false;
                this.state.businessImpactValueArray.map((item) => {
                    if (item.ImpactType === IMPACT_TO_GENPACT) {
                        if (item.MonetizableType) {
                            if (item.MonetizableType === "Increase in Revenue") {
                                monetizableSelectedDropdown = true
                            }
                            if (item.MonetizableType === "Productivity" && (item.BISubCategory && (item.BISubCategory === "FTE Equivalent - Improvement in Transaction Based Billing" || item.BISubCategory === "FTE Equivalent - Increase in Billable Hours"))) {
                                monetizableSelectedDropdown = true
                            }
                            if (monetizableSelectedDropdown) {
                                const monetizableSelectedOption = {
                                    value: 0,
                                    label: "Yes"
                                };
                                this.setState({
                                    monetizableFieldDisabled: true,
                                    monetizableProjectSelectedOption: monetizableSelectedOption
                                },()=>{
                                    this.props.monetizableProject(monetizableSelectedOption)
                                })

                                

                            }
                        }
                    }


                })
            }
        }
    }

    checkIsFtePresent = (item) => {
        let myBIMasterList = this.state.businessImpactMasterList;
        for (const pg_item of myBIMasterList) {
            if (
                item.ImpactType === pg_item.pg_impacttype &&
                item.MonetizableType === pg_item.pg_monetizabletype &&
                item.BISubCategory === pg_item.pg_bisubcategory &&
                pg_item.pg_isfteimpact === "Yes") {
                return true;
            }
        }
        return false;
    }

    handleBIFTEChange = (ImpactType, MonetizableType, BISubCategory, FTEImpact, index, event, isDollarPresent, BISrNo,item) => {
        console.log('item =>',item)
        FTEImpact = Number(Math.floor(FTEImpact + 'e2') + 'e-2');
        event.target.value = FTEImpact;
        if (FTEImpact === 0) {
            alert("You cannot set Potential Impact (# of FTE) to zero.");
            event.target.value = '';
            FTEImpact = 0;
        }
        if (FTEImpact < 0) {
            alert("You cannot set Potential Impact (# of FTE) to a negative value.");
            event.target.value = 0;
            FTEImpact = 0;
        }
        if (FTEImpact > parseInt(999)) {
            alert("You cannot set Impact (# of FTE) to more than 999. Please update accordingly.");
            event.target.value = '';
            FTEImpact = 0;
        }
        let businessImpactItem = [...this.state.businessImpactValueArray];
        if (!businessImpactItem[index]) {
            businessImpactItem[index] = {};
            businessImpactItem[index].FTEImpact = 0.0;
            businessImpactItem[index].DollarImpact = 0.0;
            businessImpactItem[index].isFTEPresent = true;
        }
        businessImpactItem[index].ImpactType = ImpactType;
        businessImpactItem[index].MonetizableType = MonetizableType;
        businessImpactItem[index].BISubCategory = BISubCategory;
        businessImpactItem[index].FTEImpact = FTEImpact;
        businessImpactItem[index].isFTEPresent = true;


        if (isDollarPresent) {
            if (businessImpactItem[index].DollarImpact && businessImpactItem[index].DollarImpact !== "") {
                if (parseInt(businessImpactItem[index].DollarImpact) < parseInt(FTEImpact)) {
                    alert("FTE Impact cannot be more than $ Impact, please recheck.");
                }
            }
        }
        console.log(businessImpactItem[index].OHRSumFTE)
        if (businessImpactItem[index].OHRSumFTE) {
            if (parseFloat(FTEImpact) < parseFloat(businessImpactItem[index].OHRSumFTE)) {
                alert("Warning: FTE impact is less than FTE already uploaded on Global productivity tool. Please ensure that correct FTE impact is updated on Value Delivery form as well as the Global Productivity Module.");
                event.target.value = '';
                FTEImpact = 0;
            }
        }
        console.log()
     
        this.setState({
            businessImpactValueArray: businessImpactItem,
        },()=>{
            this.newBusinessImpactSummary();
        })
    }

    handleBIDollarChange = (ImpactType, SrNo, MonetizableType, BISubCategory, dollarValue, index, event, isFTEPresent) => {
        dollarValue = Number(Math.floor(dollarValue + 'e2') + 'e-2');
        event.target.value = dollarValue;
        if (dollarValue === 0) {
            alert("You cannot set Potential $ Impact to zero.");
            event.target.value = '';
            dollarValue = 0;
        }
        if (dollarValue < 0) {
            alert("You cannot set Potential $ Impact to a negative value.");
            event.target.value = 0;
            dollarValue = 0;
        }
        if (dollarValue > 500000000) {
            alert("You cannot set Potential $ Impact to more than 500 million. Please update accordingly.");
            event.target.value = '';
            dollarValue = 0;
        }

        let businessImpactItem = [...this.state.businessImpactValueArray];
        if (!businessImpactItem.find(item => item.SrNo === SrNo)) {
            businessImpactItem.push({
                SrNo: SrNo,
                DollarImpact: 0.0,
                FTEImpact: 0.0,
                ImpactType: ImpactType,
                MonetizableType: MonetizableType,
                BISubCategory: BISubCategory,
            });
        }

        businessImpactItem = businessImpactItem.map(item => {
            if (item.SrNo === SrNo) {
                item.DollarImpact = dollarValue;
                item.ImpactType = ImpactType;
                item.MonetizableType = MonetizableType;
                item.BISubCategory = BISubCategory;
            }
            return item;
        });
        this.setState({ businessImpactValueArray: businessImpactItem })


        if (isFTEPresent) {
            if (businessImpactItem[index].fteValue && businessImpactItem[index].fteValue !== "") {
                if (parseInt(businessImpactItem[index].fteValue) > parseInt(dollarValue)) {
                    alert("FTE Impact cannot be more than $ Impact, please recheck.");
                }
            }
        }
        let dollarTotal = 0.0;
        businessImpactItem.map((item) => {
            if (item && item.DollarImpact) {
                dollarTotal += parseFloat(item.DollarImpact);
            }
            return true;
        });

        if ((parseInt(dollarTotal) >= parseInt(this.state.mbbLimit))) { }
        else {
            showMBBWarningOnce = 0;
        }
        if (showMBBWarningOnce === 0 && (parseInt(dollarTotal) >= parseInt(this.state.mbbLimit))) {
            window.alert("Please note: As your $ Impact is greater than or equal to 50K, the approval will be sent to MBB.");
            showMBBWarningOnce = 1;
        }

        this.setState({
            businessImpactValueArray: businessImpactItem,
        },()=>{this.newBusinessImpactSummary()})
        
    }

    // checkIfMonetizationFlowToBeDisabled = (createdDate) => {
    //     let response = false;
    //     if (new Date(this.state.createdDate).getTime() > new Date(MONETIZATION_FLOW_DISABLED_DATE).getTime()) {
    //         response = true;
    //     } else {
    //         response = false;
    //     }
    //     return response;
    // }



    newBusinessImpactSummary = async () => {
        let localSummaryData = [...this.state.businessImpactValueArray];
        
        // this is for VD Summary
        const summaryGroupedData = localSummaryData.reduce((accumulator, currentValue) => {
            const ImpactType = currentValue.ImpactType;
            const MonetizableType = currentValue.MonetizableType;
            const FTEImpact = parseFloat(currentValue.FTEImpact) || 0.0;
            const DollarImpact = parseFloat(currentValue.DollarImpact) || 0.0;

            const existingRow = accumulator.find(row => row.ImpactType === ImpactType && row.MonetizableType === MonetizableType);
            if (existingRow) {
                existingRow.FTEImpact += FTEImpact
                existingRow.DollarImpact += DollarImpact
            } else {
                accumulator.push({ ImpactType, MonetizableType, FTEImpact, DollarImpact });
            }
            return accumulator;
        }, []);

        let sortedSummaryIndex = summaryGroupedData.sort((a, b) => a.ImpactType.toLowerCase().localeCompare(b.ImpactType.toLowerCase()))
        this.setState({ summaryArray: sortedSummaryIndex },()=>{})

        await this.props.func(this.state.businessImpactValueArray)

        // calculate total FTE and Dollar based on 
        if (this.state.businessImpactValueArray && this.state.monetizableProjectSelectedOption?.label === "Yes") {
            let localtotaldollar = 0.0;
            let localtotalfte = 0.0;
            if (this.state.monetizationStatusSelectedOption?.label !== "Approved by Client") {
                let abc = [];
                this.state.businessImpactValueArray.filter((item) => {
                    if (item.IsMonetized === "No" || item.IsMonetized === "" || !item.IsMonetized) {
                        abc.push(item)
                    }
                })
                abc.map((item) => {
                    if (item && item.DollarImpact) {
                        localtotaldollar += parseFloat(item.DollarImpact);
                    }
                    if (item && item.FTEImpact) {
                        localtotalfte += parseFloat(item.FTEImpact);
                    }
                })
            }
            if (this.state.monetizationStatusSelectedOption?.label === "Approved by Client") {
                this.state.businessImpactValueArray.map((item) => {
                    if (item && item.DollarImpact) {
                        localtotaldollar += parseFloat(item.DollarImpact);
                    }
                    if (item && item.FTEImpact) {
                        localtotalfte += parseFloat(item.FTEImpact);
                    }
                })
                
            }
            this.setState({
                finalImpactDollar: localtotaldollar,
                finalImpactFTE: localtotalfte
            })
        }

        // sum up monetized values only
        if (this.state.businessImpactValueArray ) {
            let MonetizedBiArray = [];
            let fteValue = 0;
            let dollarValue = 0;
            this.state.businessImpactValueArray.filter((item) => {
                if (item.IsMonetized === "Yes") {
                    MonetizedBiArray.push(item)
                }
            })
            if (MonetizedBiArray) {
                const groupedData = MonetizedBiArray.reduce((accumulator, currentValue) => {
                    const ImpactType = currentValue.ImpactType;
                    const fteValue = parseFloat(currentValue.FTEImpact) || 0.0;
                    const dollarValue = parseFloat(currentValue.DollarImpact) || 0.0;
                    const existingRow = accumulator.find(row => row.ImpactType === ImpactType);
                    if (existingRow) {
                        existingRow.fteValue += fteValue
                        existingRow.dollarValue += dollarValue
                    }
                    else {
                        accumulator.push({ ImpactType, fteValue, dollarValue });
                    }
                    return accumulator;
                }, []);
                if (groupedData.length === 0) {
                    fteValue = 0
                    dollarValue = 0
                } else {
                    fteValue = groupedData[0].fteValue
                    dollarValue = groupedData[0].dollarValue
                }
                this.setState({
                    totalMonetizedFTE: fteValue,
                    totalMonetizedDollar: dollarValue
                })
            }
        }

        // Productivity - this is to show/hide client fields based on impacat at client productivity categories selected
        if (this.state.impactOptionSelected && (this.state.impactOptionSelected.label === VD_TO_CLIENT || this.state.impactOptionSelected.label === VD_TO_CLIENT_PLUS_GENPACT)) {
            let clientNonProductivity = this.state.businessImpactValueArray && this.state.businessImpactValueArray.some((e) => e.ImpactType === IMPACT_TO_CLIENT && ["Increase in Revenue", "Reduction in Cost", "Cash Impact", "Others"].includes(e.MonetizableType));
            if (clientNonProductivity) {
                this.setState({ showClientFields: true }, () => { })
            } else {
                this.setState({ showClientFields: false }, () => { })
                let genpactNonProducitivity = this.state.businessImpactValueArray.some((e) => e.ImpactType === IMPACT_TO_GENPACT && ["Increase in Revenue", "Reduction in Cost", "Cash Impact", "Others"].includes(e.MonetizableType));
                if (genpactNonProducitivity) {
                } else {
                    this.setState({ showClientFields: false }, () => { })
                }
            }
        }

    }

    removeBiFormRow = (event, item) => {
        console.log('item received to delete',item)
        const DeleteSrno = item.SrNo;
        if (item.PValid && item.PValid === "Yes") {
            const confirmDelete = window.confirm("Are you sure you want to delete the productivity line item ? Deleting these line items will delete productive OHRs.");
            if (confirmDelete) {
                this.deleteProductiveLineItem(DeleteSrno)
            } else {
                return;
            }
        }

        if (item.PValid && item.PValid === "FTE") {
            if (item.OHRSumFTE) {
                const confirmDelete = window.confirm("Are you sure you want to delete the productivity line item ? Deleting these line items will delete productive OHRs.");
                if (confirmDelete) {
                    this.deleteProductivityFTE(DeleteSrno)
                } else {
                    return;
                }
            }

        }


        const filteredIdeaArray = this.state.businessImpactValueArray.filter((item) => item.SrNo !== DeleteSrno);
        this.setState({ businessImpactValueArray: filteredIdeaArray },()=>{
            this.newBusinessImpactSummary();
        })
        
        this.props.fetchDeletedBIRows(filteredIdeaArray);

        if (filteredIdeaArray.length > 0 && filteredIdeaArray.some((e) => e.ImpactType === IMPACT_TO_GENPACT && ["Increase in Revenue", "Reduction in Cost"].includes(e.monetizableType))) {
            this.setState({ appropriateAttachment: true},()=>{})
        }

        if (filteredIdeaArray.some((e) => e.ImpactType === IMPACT_TO_GENPACT && ["Increase in Revenue"].includes(e.MonetizableType))) {
            this.setState({ monetizableFieldDisabled: true })
        } else {
            this.setState({ monetizableFieldDisabled: false, monetizedAlertCounter: 0 })
        }
        
    };


    deleteProductiveLineItem = (SrNo) => {
        return new Promise((resolve, reject) => {
            Toast.loading("Deleting records. Please wait...", () => { });
            let param = {}
            param = {
                case: "new",
                casetype: "deleteProductivityDetails",
                IdeaIDAlpha: this.state.IdeaIDAlpha,
                SrNo: SrNo,
                IdeaId: this.props.IdeaId,
                ProjectID: this.props.IdeaId,
                //ProjectID:LeanId,

            }
            const requestOptions = {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + this.accessToken,
                },
                body: JSON.stringify(param)
            };
            fetch(`${REVIEW_IDEA_URL}`, requestOptions)
                .then(response => response.json())
                .then(data => {
                    Toast.hide()
                    if (data.Message === "Deleted succesfully") {
                        Toast.success("Record deleted successfully.", 3000, () => { });
                        resolve()
                    } else {
                        reject();
                        console.log(data)
                    }

                })
        })
    }

    deleteProductivityFTE=(SrNo)=>{
        return new Promise((resolve, reject) => {
            Toast.loading("Deleting records. Please wait...", () => { });
            let param = {}
            param = {
                case: "new",
                casetype: "delProductivityFTEDetails",
                IdeaIDAlpha: this.state.IdeaIDAlpha,
                SrNo: SrNo,
                IdeaId: this.props.IdeaId,
                ProjectID: this.props.IdeaId,
                //ProjectID:LeanId,

            }
            const requestOptions = {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + this.accessToken,
                },
                body: JSON.stringify(param)
            };
            fetch(`${PRODUCTIVITY_PROJECTS_UPDATE_URL}`, requestOptions)
                .then(response => response.json())
                .then(data => {
                    Toast.hide()
                    if (data.Message === "Deleted succesfully") {
                        Toast.success("Record deleted successfully.", 3000, () => { });
                        resolve()
                    } else {
                        reject();
                        console.log(data)
                    }

                })
        })
    }



    




    // renderMonetizableOptions = () => {
    //     let options = [];
    //     MONETIZATIONOPTIONS.map((item) => {
    //         options.push({
    //             value: item.value,
    //             label: item.label
    //         })
    //         return options;
    //     });
    //     return options;
    // }

    handleSowIdChange = (e) => {
        if (e.length <= 30) {
            this.setState({SowID:e})
            this.props.fetchMonetizationSowID(e)
        } else {
            window.alert("SOW ID/SFDC/OLI ID cannot be more than 30 characters.");
            return;
        }

    }

    // auto fetch FPNA name for monetization starts here...
    handleFpnaOhrMonetizationOnCut = (event) => {
        let abc = event.target.value.trim();
        this.setState({FPnAOHRMonetization:abc},()=>{})
        if (event.value === undefined) {
            this.setState({FPnAOHRMonetization:"",FPnANameMonetization:""},()=>{})
            this.props.fetchMonetizationFpnaName("")
            this.props.fetchMonetizationFpnaOhr("")
        }
        else if (event.value.length === 9) {
            this.handleFpnaOhrMonetizationChange()
        }
        else {
            this.setState({FPnANameMonetization:""},()=>{})
            this.props.fetchMonetizationFpnaName("")
            this.props.fetchMonetizationFpnaOhr("")
        }
    }
    handleFpnaOhrMonetizationChange = (event) => {
        let abc = event.target.value.trim();
        this.setState({FPnAOHRMonetization:abc},()=>{})
        var numbers = /^[0-9]+$/;
        if (event !== null && event !== undefined) {
            if (event.target.value.match(numbers) && event.target.value.length !== 0) {
                if (event.target.value.length === 9) {
                    let localFPNAOHRForMonetization = event.target.value;
                    this.fetchSubmitFpnaOHRMonetizationDetails(localFPNAOHRForMonetization);
                }
                else {
                    this.setState({FPnAOHRMonetization:"",FPnANameMonetization:""},()=>{})
                    this.props.fetchMonetizationFpnaName("")
                    this.props.fetchMonetizationFpnaOhr("")
                }
            } else {
                this.setState({FPnAOHRMonetization:"",FPnANameMonetization:""},()=>{})
                this.props.fetchMonetizationFpnaName("")
                this.props.fetchMonetizationFpnaOhr("")
            }
        }
    }


    fetchSubmitFpnaOHRMonetizationDetails = (localFPNAOHRForMonetization) => {
        Toast.loading("Fetching FP&A full name details for monetization. Please wait...", () => { });
        const param = {
            EntityType: "OHR",
            EntityName: localFPNAOHRForMonetization
        }
        const requestOptions = {
            method: 'POST',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + this.accessToken,

            },
            body: JSON.stringify(param)
        };
        fetch(GET_METADATA, requestOptions)
            .then(response => response.json())
            .then(data => {
                let requestByName = "";
                if (data.DNAUsers) {
                    if (data.DNAUsers.Table1 && data.DNAUsers.Table1.length > 0) {
                        requestByName = data.DNAUsers.Table1[0].pg_username;
                    }
                }
                Toast.hide();
                if (requestByName === "" || requestByName === null || requestByName === undefined || !requestByName) {
                    Toast.fail("We could not find FP&A full name details based on the entered OHR. Please check and re-enter.", 5000, () => { });
                    this.setState({FPnAOHRMonetization:"",FPnANameMonetization:""},()=>{})
                } else {
                    this.setState({FPnAOHRMonetization:localFPNAOHRForMonetization,FPnANameMonetization:requestByName},()=>{})
                    this.props.fetchMonetizationFpnaName(requestByName)
                    this.props.fetchMonetizationFpnaOhr(localFPNAOHRForMonetization)
                }
            })
            .catch(error => {
                console.log("error =>",error)
                Toast.hide();
                Toast.fail('Please enter a valid FP&A OHR for FP&A Name for monetization.', 5000, () => { });
            });
    }
    // auto fetch fpna full name ends here 


    // auto fetch gol name for monetization starts here
    handleGOLOhrMonetizationOnCut = (event) => {
        let abc = event.target.value.trim();
        this.setState({GOLOHRMonetization:abc},()=>{})
        
        if (event.value === undefined) {
           this.setState({GOLOHRMonetization:"",GOLNameMonetization:""},()=>{})
            this.props.fetchMonetizationGOLName("")
            this.props.fetchMonetizationGOLOhr("")
        }
        else if (event.value.length === 9) {
            this.handleGOLOhrMonetizationChange()
        }
        else {
            this.setState({GOLNameMonetization:""},()=>{})
            this.props.fetchMonetizationGOLName("")
            this.props.fetchMonetizationGOLOhr("")
        }
    }
    handleGOLOhrMonetizationChange = (event) => {
        let abc = event.target.value.trim();
        var numbers = /^[0-9]+$/;
        if (event !== null && event !== undefined) {
            if (event.target.value.match(numbers) && event.target.value.length !== 0) {
                if (event.target.value.length === 9) {
                    let localGOLOHRMOnetization = event.target.value;
                    this.fetchSubmitGOLOHRMonetizationDetails(localGOLOHRMOnetization);
                }
                else {
                    this.setState({GOLOHRMonetization:"",GOLNameMonetization:""},()=>{})
                    this.props.fetchMonetizationGOLName("")
                    this.props.fetchMonetizationGOLOhr("")
                }
            } else {
                this.setState({GOLOHRMonetization:"",GOLNameMonetization:""},()=>{})
                this.props.fetchMonetizationGOLName("")
                this.props.fetchMonetizationGOLOhr("")

            }
        }
    }

    fetchSubmitGOLOHRMonetizationDetails = (localGOLOHRMonetization) => {
        Toast.loading("Fetching GOL full name details for monetization. Please wait...", () => { });
        const param = {
            EntityType: "OHR",
            EntityName: localGOLOHRMonetization
        }
        const requestOptions = {
            method: 'POST',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + this.accessToken,

            },
            body: JSON.stringify(param)
        };
        fetch(GET_METADATA, requestOptions)
            .then(response => response.json())
            .then(data => {
                let requestByName = "";
                if (data.DNAUsers) {
                    if (data.DNAUsers.Table1 && data.DNAUsers.Table1.length > 0) {
                        requestByName = data.DNAUsers.Table1[0].pg_username;
                    }
                }
                Toast.hide();
                if (requestByName === "" || requestByName === undefined || requestByName === null || !requestByName) {
                    Toast.fail("We could not find GOL full name details based on the entered OHR. Please check and re-enter.", 5000, () => { });
                    this.setState({GOLNameMonetization:""},()=>{})
                } else {
                    this.setState({GOLOHRMonetization:localGOLOHRMonetization,GOLNameMonetization:requestByName},()=>{})
                    this.props.fetchMonetizationGOLName(requestByName)
                    this.props.fetchMonetizationGOLOhr(localGOLOHRMonetization)
                }
            })
            .catch(error => {
                Toast.hide();
                Toast.fail('Please enter a valid GOL OHR for GOL OHR for monetization.', 5000, () => { });
            });
    }

    // auto fetch gol name for monetization ends here



    // auto fetch fpna full name for monetization starts here 

    renderImpactOptions = () => {
        let options = [];
        if (this.props.bbMonetizationApproval) {
            IMPACTOPTIONS.slice(-2).map((item) => {
                options.push({
                    value: item.value,
                    label: item.label
                })
                return options;
            });
        } else {
            IMPACTOPTIONS.map((item) => {
                options.push({
                    value: item.value,
                    label: item.label
                })
                return options;
            });
        }
        return options;
    }

    handleVDTypeChange = (e) => {
        if (window.confirm("Value Delivery form will be filtered basis the Value Delivery option selected. Do you wish to continue?")) {
            this.setState({
                monetizableFieldDisabled: false,
                monetizableProjectSelectedOption: [],
                monetizationStatusSelectedOption: []
            }, () => {
                this.props.monetizableProject([])
                this.props.monetizableStatus([])

            })
            this.setState({impactOptionSelected: e,})
            this.props.vdType(e)
            if (e.label === NO_VD) {
                this.setState({
                    businessImpactValueArray: [],

                    monetizableProjectSelectedOption: [],monetizationStatusSelectedOption: [],
                    
                    finalImpactDollar: "",finalImpactFTE: "",
                    
                    showClientFields: false,clientName: "",clientRole: "", clientSignOffDate: "",
                    
                    showGOLFields: false,golOhr: "", GOLName: "",fpnaOhr: "",fpnaName: "",

                    FPnANameMonetization:"", FPnAOHRMonetization:"",GOLOHRMonetization:"",GOLNameMonetization:"",SowID: "",

                    // filename1: "",fileType1: "",base64File1: "",

                    filename2: "",fileType2: "",base64File2: "",

                    filename3: "",base64File3: "",fileType3: "",

                    filename4: "",fileType4: "",base64File4: "",

                    
                    myObj: [],
                })

            }
            if (e.label === VD_TO_CLIENT) {
                this.filterBIRows(VD_TO_CLIENT);
                this.setState({ showClientFields: true, showGOLFields: true }, () => { })
            }
            if (e.label === VD_TO_GENPACT) {
                this.filterBIRows(VD_TO_GENPACT);
                this.setState({ showClientFields: false, showGOLFields: true ,
                    clientName: "",clientRole: "", clientSignOffDate: "",
                }, () => { })
                this.props.fetchClientName("")
                this.props.fetchClientRole("")
                this.props.fetchClientSignOffDate("")
            }
            if (e.label === VD_TO_CLIENT_PLUS_GENPACT) {
                this.setState({ showClientFields: true, showGOLFields: true }, () => { })
            }
        }
    }
    filterBIRows = (label) => {
        return new Promise((resolve, reject) => {
            let localVDType = "";

            // HC Release categories
            // Impact at Genpact - Reduction to Over Deployment Bench - 120
            // Impact at Genpact - RGFTE HC Reduction - 122
            // Impact at Client - RGFTE HC Reduction - 121
            
            // FTE Eq Categories - 
            // Impact at Genpact FTE Equivalent - Improvement in Transaction Based Billing - 117
            // Impact at Genpact FTE Equivalent - Increase in Billable Hours - 118 
            // Impact at Client - FTE Equivalent - Absorbed more work with same HC/Cost - 119
            
            
            if (label === VD_TO_CLIENT) {
                localVDType = IMPACT_TO_GENPACT;
            }
            if (label === VD_TO_GENPACT) {
                localVDType = IMPACT_TO_CLIENT;
            }

            this.state.businessImpactValueArray && this.state.businessImpactValueArray.forEach((item, index) => {
                const { PValid, ImpactType, MonetizableType, SrNo, OHRSumFTE } = item;
                if (ImpactType === localVDType) {
                    if (MonetizableType === 'Productivity') {
                        if (PValid === "Yes") {
                            this.deleteProductiveLineItem(SrNo)
                        }
                        if (PValid === "FTE") {
                            if (OHRSumFTE) {
                                this.deleteProductivityFTE(SrNo)
                            }
                        }
                    }
                }
            })

            let sortType='';
            if (label === VD_TO_CLIENT) {
                sortType = IMPACT_TO_CLIENT;
            }
            if (label === VD_TO_GENPACT) {
                sortType = IMPACT_TO_GENPACT;
            }

            let businessImpactItem = [...this.state.businessImpactValueArray];
            businessImpactItem = businessImpactItem.filter(item => {
                return item.ImpactType === sortType;
            });
            this.setState({
                businessImpactValueArray:businessImpactItem
            },()=>{this.newBusinessImpactSummary();})
            resolve();
        })
    }


    // function to fetch fpna file for monetization
    showMonetizationContent = async() => {
        try {
            Toast.loading("Fetching FP&A Sign-off for monetization content...", () => { });
            const requestOptions = {
                method: 'GET',
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + this.accessToken,
                }
            };
            let signoffFileType = this.state.FPnAFileTypeMonetization;
            const response = await fetch(`${GET_IDEA_URL}IdeaId=${this.props.IdeaId}&${PPT_CONTENT}=true&fpnacontent=true&fpnamonetizationcontent=true&case=doc`, requestOptions)
            if (response.ok) {
                const data = await response.json();
                if (data) {
                    const signoffMetadata = data.fpnaContent ? data.fpnaContent : "";
                    const signoffContent = "data:" + signoffFileType + ";base64," + signoffMetadata;
                    if (signoffContent) {
                        var fileData = signoffContent;
                        var fileName = this.state.FPnAFileNameMonetization;
                        var w = window.open("");
                        const downloadLink = w.document.createElement("a");
                        downloadLink.href = fileData;
                        downloadLink.download = fileName;
                        downloadLink.click();
                        Toast.hide();
                    }
                }
            }
        }
        catch (error) {
            Toast.hide();
            console.log(error)
            Toast.fail("Error while fetching FP&A Sign-off for monetization content. Please try again!", 3000, () => { });
        }
    }



    myFIleChange = (event, fileType) => {
        var file = event.target.files[0];
        var currFilename = file.name;
        var currFilesize = file.size;
        if (currFilesize > 5000000) {
            alert("The size of the document you are uploading, is more than 5MB. Please upload a smaller document.");
            return;
        }
        var validExtensions = ['.xls', '.xlsx', '.xlsm', '.csv', '.doc', '.docx', '.pdf', '.ppt', '.pptx', '.pdf', '.jpeg', '.jpg', '.png', '.msg', '.png', '.mpp'];
        var currFileExtension = currFilename.substring(currFilename.lastIndexOf("."));
        var isFileTypeValid = validExtensions.filter((val) => val.toLowerCase().includes(currFileExtension.toLowerCase()));
        if (isFileTypeValid.length <= 0) {
            alert("The type of document you are uploading is not supported. Please upload only supported file types.");
            return;
        }
        if (fileType === "file1") {
            if (currFilename === this.state.FPnAFileNameMonetization) {
                Window.alert("You are trying to upload the same document. Please upload a different document.");
                return;
            }
        }

        var reader = new FileReader();
        reader.readAsBinaryString(file);
        reader.onload = () => {
            let fileContents = btoa(reader.result);
            if (fileType === "file1") {
                this.setState({
                    FPnAFileNameMonetization:file.name,
                    FPnAFileTypeMonetization:file.type
                })
                let fileName = file.name;
                let fileType = file.type;
                let fileContent = fileContents;
                let abc = this.state.showClientApprovalFields;
                this.props.fetchMonetizationFileDetails({
                    fileName, fileType, fileContent,
                    abc
                })
            }
        };
        reader.onerror = function () {
            console.log('There are some problems loading document contents.');
        };
    }


    uploadFile = (event, fileType) => {
        var file = event.target.files[0];
        var currFilename = file.name;
        var currFilesize = file.size;

        if (fileType === "file1") {
            if (currFilesize > 10000000) {
                alert("The size of the document you are uploading, is more than 10MB. Please upload a smaller document.");
                return;
            }
        }

        var validExtensions = ['.xls', '.xlsx', '.xlsm', '.csv', '.doc', '.docx', '.pdf', '.ppt', '.pptx', '.pdf', '.jpeg', '.jpg', '.png', '.msg', '.png', '.mpp'];
        var currFileExtension = currFilename.substring(currFilename.lastIndexOf("."));
        var isFileTypeValid = validExtensions.filter((val) => val.toLowerCase().includes(currFileExtension.toLowerCase()));
        if (isFileTypeValid.length <= 0) {
            alert("The type of document you are uploading is not supported. Please upload only supported file types.");
            return;
        }

        if (currFilename === this.state.filename2) {
            alert("You are trying to upload the same document. Please upload a different document.");
            return;
        }
        if (currFilename === this.state.filename3) {
            alert("You are trying to upload the same document. Please upload a different document.");
            return;
        }
        if (currFilename === this.state.filename4) {
            alert("You are trying to upload the same document. Please upload a different document.");
            return;
        }
        var reader = new FileReader();
        reader.readAsBinaryString(file);
        reader.onload = () =>{
            let fileContents = btoa(reader.result);
            if (fileType === "file1") {
                let fileName = file.name;
                let fileType = file.type;
                let fileContent = fileContents;
                this.setState({filename1:fileName, fileType1:fileType, base64File1:fileContent},()=>{})
                this.props.fetchPPTDeck(fileName, fileType, fileContent)
            }
        };
        reader.onerror = function () {
            console.log('There are some problems loading document contents.');
        };
    }


    uploadFileForClient = (event, fileType) => {
        var file = event.target.files[0];
        var currFilename = file.name;
        var currFilesize = file.size;

        if (currFilesize > 5000000) {
            alert("The size of the document you are uploading, is more than 5MB. Please upload a smaller document.");
            return;
        }

        var validExtensions = ['.xls', '.xlsx', '.xlsm', '.csv', '.doc', '.docx', '.pdf', '.ppt', '.pptx', '.pdf', '.jpeg', '.jpg', '.png', '.msg', '.png', '.mpp'];
        var currFileExtension = currFilename.substring(currFilename.lastIndexOf("."));
        var isFileTypeValid = validExtensions.filter((val) => val.toLowerCase().includes(currFileExtension.toLowerCase()));
        if (isFileTypeValid.length <= 0) {
            alert("The type of document you are uploading is not supported. Please upload only supported file types.");
            return;
        }
        // validation for 2nd file
        if (currFilename === this.state.filename1) {
            alert("You are trying to upload the same document. Please upload a different document.");
            return;
        }
        if (currFilename === this.state.filename3) {
            alert("You are trying to upload the same document. Please upload a different document.");
            return;
        }
        if (currFilename === this.state.filename4) {
            alert("You are trying to upload the same document. Please upload a different document.");
            return;
        }
        var reader = new FileReader();
        reader.readAsBinaryString(file);
        reader.onload = ()=> {
            let fileContents = btoa(reader.result);
            if (fileType === "file2") {
                let localgolFileName = file.name;
                let localgolFileType = file.type;
                let localgolFileBase60 = fileContents;
                this.setState({filename2:localgolFileName,fileType2:localgolFileType,base64File2:localgolFileBase60})
                this.props.fetchClientDocName(localgolFileName)
                this.props.fetchClientDocType(localgolFileType)
                this.props.fetchClientDocContent(localgolFileBase60)

            }

        };
        reader.onerror = function () {
            console.log('There are some problems loading document contents.');
        };
    }

    uploadFileForGol = (event, fileType) => {
        if (this.state.filename3) {
            if (window.confirm("Uploading GOL Approval document would replace the '" + this.state.filename3 + "' document. Do you wish to continue ?")) {
                var file = event.target.files[0];
                var currFilename = file.name;
                var currFilesize = file.size;
                if (fileType === "file3") {
                    if (currFilesize > 2621440) {
                        alert("The size of the document you are uploading, is more than 2.5MB. Please upload a smaller document.");
                        return;
                    }

                }
                var validExtensions = ['.xls', '.xlsx', '.xlsm', '.csv', '.doc', '.docx', '.pdf', '.ppt', '.pptx', '.pdf', '.jpeg', '.jpg', '.png', '.msg', '.png', '.mpp'];
                var currFileExtension = currFilename.substring(currFilename.lastIndexOf("."));
                var isFileTypeValid = validExtensions.filter((val) => val.toLowerCase().includes(currFileExtension.toLowerCase()));
                if (isFileTypeValid.length <= 0) {
                    alert("The type of document you are uploading is not supported. Please upload only supported file types.");
                    return;
                }

                // validation for 3rd file
                if (currFilename === this.state.filename1) {
                    alert("You are trying to upload the same document. Please upload a different document.");
                    return;
                }
                if (currFilename === this.state.filename2) {
                    alert("You are trying to upload the same document. Please upload a different document.");
                    return;
                }
                if (currFilename === this.state.filename4) {
                    alert("You are trying to upload the same document. Please upload a different document.");
                    return;
                }


                var reader = new FileReader();
                reader.readAsBinaryString(file);
                reader.onload = ()=> {
                    let fileContents = btoa(reader.result);
                    if (fileType === "file3") {
                        let localgolFileName = file.name;
                        let localgolFileType = file.type;
                        let localgolBase60 = fileContents;
                        this.setState({filename3:localgolFileName,fileType3:localgolFileType,base64File3:localgolBase60},()=>{})
                        this.props.fetchGolDocName(localgolFileName)
                        this.props.fetchGolDocType(localgolFileType)
                        this.props.fetchGolDocContent(localgolBase60)

                    }
                };
                reader.onerror = function () {
                    console.log('There are some problems loading document contents.');
                };
            }
        }
        else {
            var file = event.target.files[0];
            var currFilename = file.name;
            var currFilesize = file.size;
            if (fileType === "file3") {
                if (currFilesize > 2621440) {
                    alert("The size of the document you are uploading, is more than 2.5MB. Please upload a smaller document.");
                    return;
                }

            }
            var validExtensions = ['.xls', '.xlsx', '.xlsm', '.csv', '.doc', '.docx', '.pdf', '.ppt', '.pptx', '.pdf', '.jpeg', '.jpg', '.png', '.msg', '.png', '.mpp'];
            var currFileExtension = currFilename.substring(currFilename.lastIndexOf("."));
            var isFileTypeValid = validExtensions.filter((val) => val.toLowerCase().includes(currFileExtension.toLowerCase()));
            if (isFileTypeValid.length <= 0) {
                alert("The type of document you are uploading is not supported. Please upload only supported file types.");
                return;
            }

            // validation for 3rd file
            if (currFilename === this.state.filename1) {
                alert("You are trying to upload the same document. Please upload a different document.");
                return;
            }
            if (currFilename === this.state.filename2) {
                alert("You are trying to upload the same document. Please upload a different document.");
                return;
            }
            if (currFilename === this.state.filename4) {
                alert("You are trying to upload the same document. Please upload a different document.");
                return;
            }


            var reader = new FileReader();
            reader.readAsBinaryString(file);
            reader.onload = () =>{
                let fileContents = btoa(reader.result);
                if (fileType === "file3") {
                    let localgolFileName = file.name;
                    let localgolFileType = file.type;
                    let localgolBase60 = fileContents;
                    this.setState({filename3:localgolFileName,fileType3:localgolFileType,base64File3:localgolBase60},()=>{})
                    this.props.fetchGolDocName(localgolFileName)
                    this.props.fetchGolDocType(localgolFileType)
                    this.props.fetchGolDocContent(localgolBase60)
                    const updatedItems = this.state.myObj.map((item, i) => {
                        if (i === 0) {
                            return { ...item, label: localgolFileName };
                        }
                        return item;
                    });
                    this.setState({myObj:updatedItems})
                    this.props.fetchFileDetails(this.state.myObj)

                }
            };
            reader.onerror = function () {
                console.log('There are some problems loading document contents.');
            };
        }
    }
    uploadFileForFpna = (event, fileType) => {
        if (this.state.filename4) {
            if (window.confirm("Uploading FP&A Approval document would replace the '" + this.state.filename4 + "' document. Do you wish to continue ?")) {
                var file = event.target.files[0];
                var currFilename = file.name;
                var currFilesize = file.size;
                if (this.state.fileType === "file4" || this.state.fileType === "replaceFpnaDoc") {
                    if (currFilesize > 2621440) {
                        alert("The size of the document you are uploading, is more than 2.5MB. Please upload a smaller document.");
                        return;
                    }
                }
                var validExtensions = ['.xls', '.xlsx', '.xlsm', '.csv', '.doc', '.docx', '.pdf', '.ppt', '.pptx', '.pdf', '.jpeg', '.jpg', '.png', '.msg', '.png', '.mpp'];
                var currFileExtension = currFilename.substring(currFilename.lastIndexOf("."));
                var isFileTypeValid = validExtensions.filter((val) => val.toLowerCase().includes(currFileExtension.toLowerCase()));
                if (isFileTypeValid.length <= 0) {
                    alert("The type of document you are uploading is not supported. Please upload only supported file types.");
                    return;
                }

                // validation for 4th file
                if (currFilename === this.state.filename1) {
                    alert("You are trying to upload the same document. Please upload a different document.");
                    return;
                }
                if (currFilename === this.state.filename2) {
                    alert("You are trying to upload the same document. Please upload a different document.");
                    return;
                }
                if (currFilename === this.state.filename3) {
                    alert("You are trying to upload the same document. Please upload a different document.");
                    return;
                }

                if (this.state.replaceFpnaDoc) {
                    // validation for replaced fpna document
                    if (currFilename === this.state.filename1) {
                        alert("You are trying to upload the same document. Please upload a different document.");
                        return;
                    }
                    if (currFilename === this.state.filename2) {
                        alert("You are trying to upload the same document. Please upload a different document.");
                        return;
                    }
                    if (currFilename === this.state.filename3) {
                        alert("You are trying to upload the same document. Please upload a different document.");
                        return;
                    }
                    if (currFilename === this.state.filename4) {
                        alert("You are trying to upload the same document. Please upload a different document.");
                        return;
                    }
                }
                var reader = new FileReader();
                reader.readAsBinaryString(file);
                reader.onload = ()=> {
                    let fileContents = btoa(reader.result);
                    if (fileType === "file4") {
                        let localfileName = file.name;
                        let localfileType = file.type;
                        let localBase60 = fileContents;
                        this.setState({filename4:localfileName,fileType4:localfileType,base64File4:localBase60, replaceFpnaDoc:true},()=>{})
                        this.props.fetchfpnaDocName(localfileName)
                        this.props.fetchfpnaDocType(localfileType)
                        this.props.fetchfpnaDocContent(localBase60)
                    }

                    if (fileType === "replaceFpnaDoc") {
                        let localfileName = file.name;
                        let localfileType = file.type;
                        let localBase60 = fileContents;
                        this.setState({filename4:localfileName,fileType4:localfileType,base64File4:localBase60},()=>{})
                    }
                };
                reader.onerror = function () {
                    console.log('There are some problems loading document contents.');
                };
            }
        }
        else {
            var file = event.target.files[0];
            var currFilename = file.name;
            var currFilesize = file.size;
            if (fileType === "file4" || fileType === "replaceFpnaDoc") {
                if (currFilesize > 2621440) {
                    alert("The size of the document you are uploading, is more than 2.5MB. Please upload a smaller document.");
                    return;
                }
            }
            var validExtensions = ['.xls', '.xlsx', '.xlsm', '.csv', '.doc', '.docx', '.pdf', '.ppt', '.pptx', '.pdf', '.jpeg', '.jpg', '.png', '.msg', '.png', '.mpp'];
            var currFileExtension = currFilename.substring(currFilename.lastIndexOf("."));
            var isFileTypeValid = validExtensions.filter((val) => val.toLowerCase().includes(currFileExtension.toLowerCase()));
            if (isFileTypeValid.length <= 0) {
                alert("The type of document you are uploading is not supported. Please upload only supported file types.");
                return;
            }

            // validation for 4th file
            if (currFilename === this.state.filename1) {
                alert("You are trying to upload the same document. Please upload a different document.");
                return;
            }
            if (currFilename === this.state.filename2) {
                alert("You are trying to upload the same document. Please upload a different document.");
                return;
            }
            if (currFilename === this.state.filename3) {
                alert("You are trying to upload the same document. Please upload a different document.");
                return;
            }

            if (this.state.replaceFpnaDoc) {
                // validation for replaced fpna document
                if (currFilename === this.state.filename1) {
                    alert("You are trying to upload the same document. Please upload a different document.");
                    return;
                }
                if (currFilename === this.state.filename2) {
                    alert("You are trying to upload the same document. Please upload a different document.");
                    return;
                }
                if (currFilename === this.state.filename3) {
                    alert("You are trying to upload the same document. Please upload a different document.");
                    return;
                }
                if (currFilename === this.state.filename4) {
                    alert("You are trying to upload the same document. Please upload a different document.");
                    return;
                }
            }
            var reader = new FileReader();
            reader.readAsBinaryString(file);
            reader.onload = ()=> {
                let fileContents = btoa(reader.result);
                if (fileType === "file4") {
                    let localfileName = file.name;
                    let localfileType = file.type;
                    let localBase60 = fileContents;
                    this.setState({filename4:localfileName,fileType4:localfileType,base64File4:localBase60},()=>{})
                    this.props.fetchfpnaDocName(localfileName)
                    this.props.fetchfpnaDocType(localfileType)
                    this.props.fetchfpnaDocContent(localBase60)

                    const updatedItems = this.state.myObj.map((item, i) => {
                        if (i === 1) {
                            return { ...item, label: localfileName };
                        }
                        return item;
                    });
                    this.setState({myObj:updatedItems,replaceFpnaDoc:true},()=>{})
                    this.props.fetchFileDetails(this.state.myObj)
                }

                if (fileType === "replaceFpnaDoc") {
                    if (window.confirm("FP&A Approval document will be replaced. Do you still wish to continue?")) {
                        let localfileName = file.name;
                        let localfileType = file.type;
                        let localBase60 = fileContents;
                        this.setState({filename4:localfileName,fileType4:localfileType,base64File4:localBase60},()=>{})

                    }
                }
            };
            reader.onerror = function () {
                console.log('There are some problems loading document contents.');
            };
        }
    }

    // Gol client functions starts here

    handleClientNameChange = (e) => {
        this.setState({clientName:e},()=>{})
        this.props.fetchClientName(e)
    }
    handleClientRoleChange = (e) => {
        this.setState({clientRole:e},()=>{})
        this.props.fetchClientRole(e)
    }
    handleClientSignOffDateChange = (e) => {
        if (e !== null && e !== undefined) {
            if (new Date(e) > new Date()) {
                window.alert("Sign off date cannot be greater than current date.")
                this.setState({clientSignOffDate:""},()=>{})
                return;
            } else {

                this.props.fetchClientSignOffDate(e)
                this.setState({clientSignOffDate:e},()=>{})
            }

        }
    }
    // auto fetch gol full name starts here 

    handleGOLOhronCut = (event) => {
        if (event.target.value.length === 9) {
            this.handleGOLOhrChange();
        } else if (event.target.value.length === 0) {
            this.setState({golOhr:'',GOLName:''},()=>{})
            this.props.fetchGolOhr("")
            this.props.fetchGolName("")
            return null
        }
        else {
            Toast.fail("GOL OHR should be exactly of 9 digits", 3000, () => { })
            this.setState({GOLName:''},()=>{})
            this.props.fetchGolOhr("")
            this.props.fetchGolName("")
        }
    }

    handleGOLOhrChange = (event) => {
        var numbers = /^[0-9]+$/;
        if (event !== null && event !== undefined) {
            if (event.target.value.match(numbers) && event.target.value.length !== 0) {
                if (event.target.value.length === 9) {
                    let localGolOhr = event.target.value.trim();
                    this.setState({golOhr:localGolOhr},()=>{})
                    this.fetchSubmitGolOHRDetails(localGolOhr)
                }
                else {
                     this.setState({golOhr:'',GOLName:''},()=>{})
                    this.props.fetchGolOhr("")
                    this.props.fetchGolName("")
                }
            } else {
                 this.setState({golOhr:'',GOLName:''},()=>{})
                this.props.fetchGolOhr("")
                this.props.fetchGolName("")
            }
        } else {
             this.setState({golOhr:'',GOLName:''},()=>{})
            this.props.fetchGolOhr("")
            this.props.fetchGolName("")
        }
    }
    fetchSubmitGolOHRDetails = async (localGolOhr) => {
        Toast.loading("Fetching GOL full name details. Please wait...", () => { });
        try {
            const param = {
                EntityType: "OHR",
                EntityName: localGolOhr
            }
            const requestOptions = {
                method: 'POST',
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + this.accessToken,

                },
                body: JSON.stringify(param)
            };
            const response = await fetch(GET_METADATA, requestOptions);
            const data = await response.json();
            let requestByName = "";
            if (data.DNAUsers) {
                if (data.DNAUsers.Table1 && data.DNAUsers.Table1.length > 0) {
                    requestByName = data.DNAUsers.Table1[0].pg_username;
                }
            }

            if (requestByName === "" || requestByName === null || !requestByName) {
                Toast.fail("We could not find GOL full name details based on the entered OHR. Please check and re-enter.", 5000, () => { });
                this.setState({GOLName:''},()=>{})
            }
            else {
                this.setState({ GOLName: requestByName }, () => {
                    this.props.fetchGolOhr(localGolOhr)
                    this.props.fetchGolName(requestByName)
                })
                
            }
            Toast.hide();
        } catch (error) {
            Toast.hide();
            Toast.fail('Please enter a valid GOL OHR', 5000, () => {
                console.log(JSON.stringify(error));
            });
            this.setState({ GOLName: "",golOhr:"" }, () => {})
        }
    };
    // auto fetch gol full name ends here 

    // auto fetch fpna full name starts here 

    handleFpnaOhrChange = (event) => {
        var numbers = /^[0-9]+$/;
        if (event !== null && event !== undefined) {
            if (event.target.value.match(numbers) && event.target.value.length !== 0) {
                if (event.target.value.length === 9) {
                    let localFpnaOhr = event.target.value.trim();
                    if (localFpnaOhr) {
                        this.fetchSubmitFpnaOHRDetails(localFpnaOhr)
                    }
                }
                else {
                    this.setState({
                        fpnaOhr: "",
                        fpnaName: "",
                    }, () => { })
                    
                    this.props.fetchFpnaOhr("")
                    this.props.fetchFpnaName("")
                }
            } else {
                this.setState({
                    fpnaOhr: "",
                    fpnaName: "",
                }, () => { })
                this.props.fetchFpnaOhr("")
                this.props.fetchFpnaName("")

            }
        } else {
            this.setState({
                fpnaOhr: "",
                fpnaName: "",
            }, () => { })
            this.props.fetchFpnaOhr("")
            this.props.fetchFpnaName("")
        }
    }
    handleFpnaOhronCut = (event) => {
        if (event.target.value.length === 9) {
            this.handleFpnaOhrChange()
        } else if (event.target.value.length === 0) {
            this.setState({
                fpnaOhr: "",
                fpnaName: "",
            }, () => { })
            this.props.fetchFpnaOhr("")
            this.props.fetchFpnaName("")
            return null
        }
        else {
            Toast.fail("FP&A OHR should be exactly of 9 digits", 3000, () => { })
            this.setState({
                fpnaOhr: "",
            }, () => { })
            this.props.fetchFpnaOhr("")
            this.props.fetchFpnaName("")
        }
    }
    fetchSubmitFpnaOHRDetails = async (localFpnaOhr) => {
        Toast.loading("Fetching FP&A full name details. Please wait...", () => { });
        try {
            const param = {
                EntityType: "OHR",
                EntityName: localFpnaOhr
            }
            const requestOptions = {
                method: 'POST',
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + this.accessToken,

                },
                body: JSON.stringify(param)
            };
            const response = await fetch(GET_METADATA, requestOptions);
            const data = await response.json();
            let requestByName = "";
            if (data.DNAUsers) {
                if (data.DNAUsers.Table1 && data.DNAUsers.Table1.length > 0) {
                    requestByName = data.DNAUsers.Table1[0].pg_username;
                }
            }

            Toast.hide();
            if (requestByName === "" || requestByName === null || !requestByName || requestByName === "") {
                Toast.fail("We could not find FP&A full name details based on the entered OHR. Please check and re-enter.", 5000, () => { });
                this.setState({fpnaName:""},()=>{})

            } else {
                this.setState({fpnaName:requestByName},()=>{})
                this.props.fetchFpnaOhr(localFpnaOhr)
                this.props.fetchFpnaName(requestByName)
            }
        }
        catch (error) {
            Toast.hide();
            Toast.fail('Please enter a valid FP&A OHR', 5000, () => { });
            this.setState({fpnaName:""},()=>{})
        };
    }
    // auto fetch fpna full name ends here 



    // function to download PPT content
    showPPTContent = async () => {
        Toast.loading("Fetching Project PPT Deck content...", () => { });
        try {
            const requestOptions = {
                method: 'GET',
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + this.accessToken,
                }
            };
            let projectFileType = this.state.fileType1;
            const response = await fetch(`${GET_IDEA_URL}IdeaId=${this.props.IdeaId}&${PPT_CONTENT}=true&case=doc`, requestOptions)
            const data = await response.json();
            if (data) {
                const projectDeckMetadata = data.PPTContent ? data.PPTContent : "";
                const projectContent = "data:" + projectFileType + ";base64," + projectDeckMetadata;
                var w = window.open("");
                const downloadLink = w.document.createElement("a");
                downloadLink.href = projectContent;
                downloadLink.download = this.state.filename1;
                downloadLink.click();
                Toast.hide();
            }
        } catch (error) {
            console.log(error);
            Toast.fail("Error while fetching Project Deck content. Please try again!", 3000, () => { });
        }
    };

    // function to download client sign-off file
    showSignOffContent = async () => {
        try {
            Toast.loading("Fetching Customer Sign-off content...", () => { });
            const requestOptions = {
                method: 'GET',
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + this.accessToken,
                }
            };
            let signoffFileType = this.state.fileType2;
            const response = await fetch(`${GET_IDEA_URL}IdeaId=${this.props.IdeaId}&${SIGNOFF_CONTENT}=true&case=doc`, requestOptions)
            if (response.ok) {
                const data = await response.json();
                if (data) {
                    const signoffMetadata = data.SignoffContent ? data.SignoffContent : "";
                    const signoffContent = "data:" + signoffFileType + ";base64," + signoffMetadata;
                    var w = window.open("");
                    const downloadLink = w.document.createElement("a");
                    downloadLink.href = signoffContent;
                    downloadLink.download = this.state.filename2;
                    downloadLink.click();
                    Toast.hide();
                }
            }
        }
        catch (error) {
            console.log(error)
            Toast.fail("Error while fetching Customer Sign-off content. Please try again!", 3000, () => { });
        }
    }

    // function to download gol file data
    showGolOffContent = async () => {
        Toast.loading("Fetching GOL Approval content...", () => { });
        return new Promise((resolve, reject) => {
            const requestOptions = {
                method: 'GET',
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + this.accessToken,
                }
            };
            let golFileType = this.state.fileType3;
            fetch(`${GET_IDEA_URL}IdeaId=${this.props.IdeaId}&${PPT_CONTENT}=true&golcontent=true&case=doc`, requestOptions)
                .then(response => response.json())
                .then(data => {
                    const golMetadata = data.golContent ? data.golContent : "";
                    const golContent = "data:" + golFileType + ";base64," + golMetadata;
                    var w = window.open("");
                    const downloadLink = w.document.createElement("a");
                    downloadLink.href = golContent;
                    downloadLink.download = this.state.filename3;
                    downloadLink.click();
                    Toast.hide();
                })
        })
            .catch = (error) => {
                console.log(error)
                Toast.fail("Error while fetching GOL Approval content. Please try again!", 3000, () => { });
            }
    }

    // function to download fpna file data
    showFpnaContent = async () => {
        try {
            Toast.loading("Fetching FP&A Approval content...", () => { });
            const requestOptions = {
                method: 'GET',
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + this.accessToken,
                }
            };
            let fpnaFileType = this.state.fileType4;
            const response = await fetch(`${GET_IDEA_URL}IdeaId=${this.props.IdeaId}&${PPT_CONTENT}=true&fpnacontent=true&case=doc`, requestOptions)
            if (response.ok) {
                const data = await response.json();
                if (data) {
                    const golMetadata = data.fpnaContent ? data.fpnaContent : "";
                    const golContent = "data:" + fpnaFileType + ";base64," + golMetadata;
                    var w = window.open("");
                    const downloadLink = w.document.createElement("a");
                    downloadLink.href = golContent;
                    downloadLink.download = this.state.filename4;
                    downloadLink.click();
                    Toast.hide()
                }
            }
        }
        catch (error) {
            Toast.hide()
            console.log(error)
            Toast.fail("Error while fetching FP&A Approval content. Please try again!", 3000, () => { });
        }
    }

    deleteUploadedDoc = (id) => {
        if (id === 1) {
            this.setState({
                filename1:"",
                fileType1:"",
                base64File1:"",
            },()=>{})
            this.props.fetchPPTDeck("", "", "")
        }
        if (id === 2) {
            this.setState({
                filename2: "",
                fileType2: "",
                base64File2: "",
            }, () => { })
            this.props.fetchClientDocName("")
            this.props.fetchClientDocType("")
            this.props.fetchClientDocContent("")
        }
        if (id === 3) {
            this.setState({
                filename3:"",
                base64File3:"",
                fileType3:"",
            },()=>{})
            this.props.fetchfpnaDocName("")
            this.props.fetchfpnaDocType("")
            this.props.fetchfpnaDocContent("")

            const updatedItems = this.state.myObj.map((item, i) => {
                if (i === 0) {
                    return { ...item, label: "" };
                }
                return item;
            });
            this.setState({myObj:updatedItems},()=>{})
            this.props.fetchFileDetails(this.state.myObj)
           
        }
        if (id === 4) {
            this.setState({
                filename4: '',
                fileType4: '',
                base64File4: '',
            })
            this.props.fetchfpnaDocName("")
            this.props.fetchfpnaDocType("")
            this.props.fetchfpnaDocContent("")

            const updatedItems = this.state.myObj.map((item, i) => {
                if (i === 1) {
                    return { ...item, label: "" };
                }
                return item;
            });
            
            this.setState({myObj:updatedItems},()=>{})
            this.props.fetchFileDetails(this.state.myObj)
        }
    }


    render() {

        return (

            <div className="">

                {
                    this.state.CertificationLevelName && this.state.CertificationLevelName === "Lean" && (
                        <div className="">
                            <div id="Upload" className="u-border-1 u-border-palette-5-base u-container-style u-expanded-width u-group u-radius-6 u-shape-round u-group-7">
                                <div className="u-container-layout u-container-layout-7" style={{ borderBottom: "1px solid lightgray", marginBottom: "20px" }}>
                                    <div className="u-container-style u-group u-shape-rectangle u-group-8">
                                        <div className="u-container-layout u-container-layout-8">
                                            {
                                                !this.props.viewIdea
                                                    ?
                                                    <>
                                                        <p id="Upload" className="u-align-left u-text u-text-2" style={{ marginBottom: 10 }}>Upload Documents</p>
                                                    </>
                                                    :
                                                    <p id="Upload" className="u-align-left u-text u-text-2" style={{ marginBottom: 10 }}>Uploaded Documents</p>
                                            }

                                            {
                                                !this.props.viewIdea
                                                    ?
                                                    <>
                                                        <label style={{ fontWeight: 'normal', fontSize: 10, fontStyle: 'italic', color: 'red' }}>[Note] Supported File Types : .xls, .xlsx, .xlsm, .csv, .doc, .docx, .pdf, .ppt, .pptx, .pdf, .jpeg, .jpg, .png, .msg, .png, .mpp.</label>
                                                    </>
                                                    :
                                                    null
                                            }
                                            <label style={{ verticalAlign: 'bottom', marginBottom: -5 }}>Project Presentation Deck</label>  {!this.props.viewIdea ? <><span style={{ color: 'red' }}>*</span> <small style={{ color: "#939393", fontSize: "12px" }}>(Max Size: 10MB)</small></> : ""}
                                            <div className="row">
                                                <div className="col-md-10" style={{ marginTop: '10px' }}>
                                                    {
                                                        this.state.filename1
                                                            ?
                                                            <>
                                                                <button className={this.state.filename1 && this.state.filename1.length > 50 ? "upload_file_text_overflow" : ""} style={{ backgroundColor: 'transparent', color: '#337ab7', padding: 0 }} onClick={(e) => this.showPPTContent()}>{this.state.filename1}</button>
                                                            </>
                                                            :
                                                            <label style={{ fontWeight: 'normal', fontStyle: 'italic' }}>&nbsp;&nbsp;{this.state.filename1}</label>
                                                    }

                                                </div>
                                                <div className="col-md-2">
                                                    {
                                                        !this.props.viewIdea
                                                            ?
                                                            <>
                                                                {
                                                                    this.state.filename1
                                                                        ?
                                                                        <button disabled={this.props.bbMonetizationApproval} onClick={(e) => this.deleteUploadedDoc(1)} className="u-active-custom-color-6 u-border-2 u-border-active-black u-border-hover-black u-border-white u-btn u-btn-round u-button-style u-custom-color-3 u-hover-custom-color-6 u-radius-6 u-btn-2" style={{ marginTop: "6px" }}>&nbsp;&nbsp;<i className="fa fa-trash" aria-hidden="true"></i> &nbsp;Delete&nbsp;&nbsp;</button>
                                                                        :
                                                                        <>
                                                                            <label htmlFor="file-upload1" className="u-active-custom-color-6 u-border-2 u-border-active-black u-border-hover-black u-border-white u-btn u-btn-round u-button-style u-custom-color-3 u-hover-custom-color-6 u-radius-6 u-btn-2">&nbsp;&nbsp;+&nbsp;&nbsp;</label>
                                                                            <input id="file-upload1"
                                                                                type="file" style={{ display: 'none' }}
                                                                                onChange={(event) => this.uploadFile(event, "file1")}
                                                                                accept=".xls,.xlsx,.xlsm,.csv,.doc,.docx,.pdf,.pptx,.jpeg,.jpg,.png,.msg,.mpp,image/jpeg,image/png,application/pdf,application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, text/csv, application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.presentationml.presentation,application/msproject,application/vnd.ms-outlook"
                                                                            />
                                                                        </>
                                                                }

                                                            </>
                                                            :
                                                            null
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* ..............client approval fields starts here............... */}
                            {
                                this.state.showClientFields
                                    ?
                                    <>
                                        <div className="gol_fpna_approval_field_block" style={{ paddingTop: "20px", marginTop: "0px" }}>
                                            <p className="u-align-left u-text u-text-2">Client Approval Details</p>
                                            <div className="monetization_client_field_block">
                                                <div className="row u-align-left">
                                                    <div className="col-md-5">
                                                        <div className="monetization_client_field">
                                                            <div className="row gol_field_div">
                                                                <div className="col-md-6 ">
                                                                    <div className="">
                                                                        <span className="form-attribute">
                                                                            {!this.props.viewIdea ? <><span style={{ color: 'red' }}>* </span> </> : null}
                                                                            Client Name
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-6">
                                                                    {
                                                                        this.props.viewIdea
                                                                            ?
                                                                            <input disabled value={this.state.clientName} className="form-input disabled_input" />
                                                                            :
                                                                            this.props.bbMonetizationApproval
                                                                                ?
                                                                                <input disabled value={this.state.clientName} className="form-input disabled_input" />
                                                                                :
                                                                                <input
                                                                                    onChange={(e) => this.handleClientNameChange(e.target.value)}
                                                                                    className="textarea-css form-attribute hide_numeric_arrows"
                                                                                    value={this.state.clientName}
                                                                                />
                                                                    }

                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="monetization_client_field">
                                                            <div className="row gol_field_div">
                                                                <div className="col-md-6 ">
                                                                    <div className="">
                                                                        <span className="form-attribute">
                                                                            {!this.props.viewIdea ? <><span style={{ color: 'red' }}>* </span> </> : null}
                                                                            Client Role
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-6">
                                                                    {
                                                                        this.props.viewIdea
                                                                            ?
                                                                            <input value={this.state.clientRole} className="form-input disabled_input" disabled />
                                                                            :
                                                                            this.props.bbMonetizationApproval
                                                                                ?
                                                                                <input value={this.state.clientRole} className="form-input disabled_input" disabled />
                                                                                :
                                                                                <input value={this.state.clientRole} onChange={(e) => this.handleClientRoleChange(e.target.value)} className="textarea-css form-attribute" type="text" />
                                                                    }

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-2"></div>
                                                    <div className="col-md-5">
                                                        <div className="monetization_client_field">
                                                            <div className="row gol_field_div">
                                                                <div className="col-md-5">
                                                                    <div className="">
                                                                        <span className="form-attribute">
                                                                            {!this.props.viewIdea ? <><span style={{ color: 'red' }}>* </span> </> : null}
                                                                            Client Sign-off Date
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-7">
                                                                    {
                                                                        this.props.viewIdea
                                                                            ?
                                                                            <input type="date" value={this.state.clientSignOffDate} className="form-input disabled_input" disabled style={{ color: "#122539" }} />
                                                                            :
                                                                            this.props.bbMonetizationApproval
                                                                                ?
                                                                                <input type="date" value={this.state.clientSignOffDate} className="form-input disabled_input" disabled style={{ color: "#122539" }} />
                                                                                :
                                                                                <input 
                                                                                    onChange={(e) => this.handleClientSignOffDateChange(e.target.value)} 
                                                                                    className="textarea-css form-attribute" 
                                                                                    type="date" 
                                                                                    value={this.state.clientSignOffDate} 
                                                                                />
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="">
                                                    <div className="row u-align-left">
                                                        <div className="col-md-6">
                                                            <div className="">
                                                                <div className="row">
                                                                    <div className="col-md-10">
                                                                        <div className="row">
                                                                            <div className="col-md-10" style={{ marginTop: '10px' }}>
                                                                                <label>
                                                                                    {!this.props.viewIdea ? <><span style={{ color: 'red' }}>* </span> </> : null}
                                                                                    Client Approval
                                                                                    {!this.props.viewIdea ? <><small style={{ color: "#939393", fontSize: "12px" }}>&nbsp;(Max Size: 5MB)</small> </> : null}
                                                                                </label>
                                                                                <label style={{ fontWeight: 'normal', fontSize: 10, fontStyle: 'italic', color: 'red' }}>[Note] Supported File Types : .xls, .xlsx, .xlsm, .csv, .doc, .docx, .pdf, .ppt, .pptx, .pdf, .jpeg, .jpg, .png, .msg, .png, .mpp.</label>
                                                                                <button className={this.state.filename2 && this.state.filename2.length > 50 ? "upload_file_text_overflow" : ""} style={{ backgroundColor: 'transparent', color: '#337ab7', padding: 0 }} onClick={(e) => this.showSignOffContent()}>{this.state.filename2}</button>
                                                                            </div>
                                                                            <div className="col-md-2">
                                                                                {
                                                                                    !this.props.viewIdea
                                                                                        ?
                                                                                        <>
                                                                                            {
                                                                                                this.state.filename2
                                                                                                    ?
                                                                                                    <>
                                                                                                        <button title='client doc' disabled={this.props.bbMonetizationApproval} onClick={(e) => this.deleteUploadedDoc(2)} className="u-active-custom-color-6 u-border-2 u-border-active-black u-border-hover-black u-border-white u-btn u-btn-round u-button-style u-custom-color-3 u-hover-custom-color-6 u-radius-6 u-btn-2" style={{ marginTop: "6px" }}>&nbsp;&nbsp;<i className="fa fa-trash" aria-hidden="true"></i> &nbsp;Delete&nbsp;&nbsp;</button>
                                                                                                    </>
                                                                                                    :
                                                                                                    <>
                                                                                                        <label htmlFor="file-upload2"
                                                                                                            className="u-active-custom-color-6 u-border-2 u-border-active-black u-border-hover-black u-border-white u-btn u-btn-round u-button-style u-custom-color-3 u-hover-custom-color-6 u-radius-6 u-btn-2">&nbsp;&nbsp;+&nbsp;&nbsp;</label>
                                                                                                        <input id="file-upload2"
                                                                                                            type="file" style={{ display: 'none' }}
                                                                                                            onChange={(event) => this.uploadFileForClient(event, "file2")}
                                                                                                            accept=".xls,.xlsx,.xlsm,.csv,.doc,.docx,.pdf,.pptx,.jpeg,.jpg,.png,.msg,.mpp,image/jpeg,image/png,application/pdf,application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, text/csv, application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.presentationml.presentation,application/msproject,application/vnd.ms-outlook"
                                                                                                        />
                                                                                                    </>
                                                                                            }


                                                                                        </>
                                                                                        :
                                                                                        null
                                                                                }

                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                            </div>


                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                    :
                                    null
                            }
                            {/* ..............client approval fields ends here................. */}



                            {/* ..............GOL/ FPNA starts here............... */}
                            {
                                this.state.showGOLFields
                                    ?
                                    <>
                                        <div className="gol_fpna_approval_field_block">
                                            <p className="u-align-left u-text u-text-2">GOL / FP&A Approval Details</p>
                                            <div className="monetization_client_field_block">
                                                <div className="row u-align-left">
                                                    <div className="col-md-5">
                                                        <div className="monetization_client_field">
                                                            <div className="row gol_field_div">
                                                                <div className="col-md-6 ">
                                                                    <div className="">
                                                                        <span className="form-attribute">
                                                                            {!this.props.viewIdea ? <><span style={{ color: 'red' }}>* </span> </> : null}
                                                                            GOL OHR
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-6">
                                                                    {
                                                                        this.props.viewIdea
                                                                            ?
                                                                            <input disabled value={this.state.golOhr} className="form-input disabled_input" />
                                                                            :
                                                                            this.props.bbMonetizationApproval
                                                                                ?
                                                                                <input disabled value={this.state.golOhr} className="form-input disabled_input" />
                                                                                :
                                                                                <input pattern="\d*" maxLength="9"
                                                                                    defaultValue={this.state.golOhr}
                                                                                    onChange={(e) => this.handleGOLOhrChange(e)}
                                                                                    onCut={(e) => this.handleGOLOhronCut(e)}
                                                                                    className="textarea-css form-attribute hide_numeric_arrows" type="number"
                                                                                    onKeyDown={(evt) => (evt.key === '.' || evt.key === 'e' || evt.key === 'E' || evt.key === '+' || evt.key === '-') && evt.preventDefault()}
                                                                                    onWheel={(e) => e.target.blur()}
                                                                                />
                                                                    }

                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="monetization_client_field">
                                                            <div className="row gol_field_div">
                                                                <div className="col-md-6 ">
                                                                    <div className="">
                                                                        <span className="form-attribute">
                                                                            {!this.props.viewIdea && this.state.IsFpnaRequired ? <span style={{ color: 'red' }}>* </span> : " "}
                                                                            FP&A OHR
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-6">
                                                                    {
                                                                        this.props.viewIdea
                                                                            ?
                                                                            <input value={this.state.fpnaOhr} className="form-input disabled_input" disabled />
                                                                            :
                                                                            this.props.bbMonetizationApproval
                                                                                ?
                                                                                <input value={this.state.fpnaOhr} className="form-input disabled_input" disabled />
                                                                                :
                                                                                <input pattern="\d*" maxLength="9"
                                                                                    defaultValue={this.state.fpnaOhr}
                                                                                    onChange={(e) => this.handleFpnaOhrChange(e)}
                                                                                    onCut={(e) => this.handleFpnaOhronCut(e)}
                                                                                    className="textarea-css form-attribute hide_numeric_arrows" type="number"
                                                                                    onKeyDown={(evt) => (evt.key === '.' || evt.key === 'e' || evt.key === 'E' || evt.key === '+' || evt.key === '-') && evt.preventDefault()}
                                                                                    onWheel={(e) => e.target.blur()}
                                                                                />

                                                                    }

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-2"></div>
                                                    <div className="col-md-5">
                                                        <div className="monetization_client_field">
                                                            <div className="row gol_field_div">
                                                                <div className="col-md-5">
                                                                    <div className="">
                                                                        <span className="form-attribute">
                                                                            {!this.props.viewIdea ? <><span style={{ color: 'red' }}>* </span> </> : null}
                                                                            GOL Name
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-7">
                                                                    <input disabled value={this.state.GOLName} className="form-input disabled_input" type="text" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="monetization_client_field">
                                                            <div className="row gol_field_div">
                                                                <div className="col-md-5">
                                                                    <div className="">
                                                                        <span className="form-attribute">
                                                                            {!this.props.viewIdea && this.state.IsFpnaRequired ? <span style={{ color: 'red' }}>* </span> : " "}
                                                                            FP&A Name
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-7">
                                                                    <input disabled value={this.state.fpnaName} className="form-input disabled_input" type="text" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="">
                                                    <div className="row u-align-left">
                                                        <div className="col-md-5">
                                                            <div className="">
                                                                <div className="row">
                                                                    <div className="col-md-10">
                                                                        <label>
                                                                            {!this.props.viewIdea ? <><span style={{ color: 'red' }}>* </span> </> : null}
                                                                            GOL / FP&A Approval
                                                                            {!this.props.viewIdea ? <><small style={{ color: "#939393", fontSize: "12px" }}>&nbsp;(Max Size: 5MB)</small> </> : null}
                                                                        </label>
                                                                        <label style={{ fontWeight: 'normal', fontSize: 10, fontStyle: 'italic', color: 'red' }}>[Note] Supported File Types : .xls, .xlsx, .xlsm, .csv, .doc, .docx, .pdf, .ppt, .pptx, .pdf, .jpeg, .jpg, .png, .msg, .png, .mpp.</label>
                                                                    </div>
                                                                    <div className="col-md-2">
                                                                        {
                                                                            !this.props.viewIdea && (
                                                                                <>
                                                                                    <label disabled={this.props.bbMonetizationApproval} htmlFor="file-upload3" className="u-active-custom-color-6 u-border-2 u-border-active-black u-border-hover-black u-border-white u-btn u-btn-round u-button-style u-custom-color-3 u-hover-custom-color-6 u-radius-6 u-btn-2" >&nbsp;&nbsp;+&nbsp;&nbsp;</label>
                                                                                    <input id="file-upload3"
                                                                                        disabled={this.props.bbMonetizationApproval}
                                                                                        type="file" style={{ display: 'none' }}
                                                                                        onChange={(event) => this.state.myObj ? this.state.myObj[0].label !== "" && this.state.myObj[1].label !== "" ? window.alert("please delete an existing doc and then upload ") : this.state.myObj[0].label === "" ? this.uploadFileForGol(event, "file3") : this.uploadFileForFpna(event, "file4") : null}
                                                                                        accept=".xls,.xlsx,.xlsm,.csv,.doc,.docx,.pdf,.pptx,.jpeg,.jpg,.png,.msg,.mpp,image/jpeg,image/png,application/pdf,application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, text/csv, application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.presentationml.presentation,application/msproject,application/vnd.ms-outlook"
                                                                                    />
                                                                                </>
                                                                            )
                                                                        }
                                                                    </div>
                                                                </div>

                                                                <div className="row">
                                                                    <div className="col-md-12">
                                                                        <div className="row d_flex_align_items_center">
                                                                            <div className="col-md-10">
                                                                                <button className={this.state.myObj ? (this.state.myObj[0].label ? (this.state.myObj[0].label.length > 50 ? "upload_file_text_overflow" : "") : "") : ""} style={{ backgroundColor: 'transparent', color: '#337ab7', padding: 0 }} onClick={(e) => this.showGolOffContent()}>{this.state.myObj ? this.state.myObj[0].label : ""}</button>
                                                                            </div>
                                                                            <div className="col-md-2">
                                                                                {
                                                                                    !this.props.viewIdea && this.state.filename3 && (
                                                                                        <button disabled={this.props.bbMonetizationApproval} onClick={(e) => this.deleteUploadedDoc(3)} className="u-active-custom-color-6 u-border-2 u-border-active-black u-border-hover-black u-border-white u-btn u-btn-round u-button-style u-custom-color-3 u-hover-custom-color-6 u-radius-6 u-btn-2">&nbsp;&nbsp;<i className="fa fa-trash" aria-hidden="true"></i> &nbsp;Delete&nbsp;&nbsp;</button>
                                                                                    )
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                        <div className="">
                                                                            {
                                                                                <div className="row d_flex_align_items_center">
                                                                                    <div className="col-md-10">
                                                                                        <button className={this.state.myObj ? (this.state.myObj[1].label ? (this.state.myObj[1].label.length > 50 ? "upload_file_text_overflow" : "") : "") : ""} style={{ backgroundColor: 'transparent', color: '#337ab7', padding: 0 }} onClick={(e) => this.showFpnaContent()}>{this.state.myObj ? this.state.myObj[1].label : ""}</button>
                                                                                    </div>
                                                                                    <div className="col-md-2">
                                                                                        {
                                                                                            this.state.filename4 && !this.props.viewIdea && (
                                                                                                <button disabled={this.props.bbMonetizationApproval} onClick={(e) => this.deleteUploadedDoc(4)} className="u-active-custom-color-6 u-border-2 u-border-active-black u-border-hover-black u-border-white u-btn u-btn-round u-button-style u-custom-color-3 u-hover-custom-color-6 u-radius-6 u-btn-2" style={{ marginTop: "6px" }}>&nbsp;&nbsp;<i className="fa fa-trash" aria-hidden="true"></i> &nbsp;Delete&nbsp;&nbsp;</button>
                                                                                            )
                                                                                        }

                                                                                    </div>
                                                                                </div>
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                    :
                                    null
                            }
                            {/* ..............GOL/ FPNA starts here................. */}
                        </div>

                    )

                }





                <div className="select_impact_type">
                    <div className="row">
                        <div className="col-md-7">
                            <p className="u-align-left u-text u-text-2" style={{ marginBottom: 10 }}>Impact Type</p>
                            <div className="row d_flex_align_items_center">
                                <div className="col-md-6 text-left">
                                    <span className="form-attribute">
                                        {!this.props.viewIdea ? <><span style={{ color: 'red' }}>* </span> </> : null}
                                        What is the type of Value Delivery on this project ?
                                    </span>
                                </div>
                                <div className="col-md-6 text-left">
                                    {
                                        this.props.viewIdea
                                            ?
                                            <>
                                                <input disabled value={this.state.impactOptionSelected?.label} className="form-input disabled_input" />
                                            </>
                                            :
                                            this.props.bbMonetizationApproval
                                                ?
                                                <>
                                                    <input disabled value={this.state.impactOptionSelected?.label} className="form-input disabled_input" />
                                                </>
                                                :
                                                <Select
                                                    isSearchable={false}
                                                    options={this.renderImpactOptions()}
                                                    placeholder="Choose Impact Type"
                                                    onChange={(e) => this.handleVDTypeChange(e)}
                                                    value={this.state.impactOptionSelected}
                                                />
                                    }

                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                {
                    this.state.impactOptionSelected && this.state.impactOptionSelected?.label !== NO_VD
                        ?
                        <>
                            <div className="text-left pb-4 monetizable_project_block">
                                <p className="u-align-left u-text u-text-2">Monetizable Project ?</p>
                                <div className="row" style={{ marginTop: "10px" }}>
                                    <div className="col-md-8">
                                        <div className="row">
                                            <div className="col-md-4 gol_field_div text-left">
                                                <span className="form-attribute">
                                                    {!this.props.viewIdea ? <><span style={{ color: 'red' }}>* </span> </> : null}
                                                    Is this a monetizable project ?
                                                </span>
                                            </div>
                                            <div className="col-md-3">
                                                {
                                                    this.props.viewIdea
                                                        ?
                                                        <>
                                                            <input 
                                                                disabled 
                                                                value={this.state.monetizableProjectSelectedOption?.label} 
                                                                className="form-input disabled_input" 
                                                            />
                                                        </>
                                                        :
                                                        this.props.bbMonetizationApproval
                                                            ?
                                                            <>
                                                                <input 
                                                                    disabled value={this.state.monetizableProjectSelectedOption?.label} 
                                                                    className="form-input disabled_input" 
                                                                />
                                                            </>
                                                            :
                                                            <Select
                                                                options={YESORNO}
                                                                onChange={(e)=>this.handleMonetizableProjectChange(e)}
                                                                value={this.state.monetizableProjectSelectedOption}
                                                                isDisabled={this.state.monetizableFieldDisabled ? true : false}
                                                            />

                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                        :
                        null
                }

                {/* ..................monetization client approval process starts here.......... */}

                {
                    this.state.impactOptionSelected && this.state.monetizableProjectSelectedOption?.label === "Yes"
                        ?
                        <>
                            <div className="text-left monetizable_status_div">
                                <p className="u-align-left u-text u-text-2">Monetizable Status ?</p>
                                <div className="row" style={{ marginTop: "10px" }}>
                                    <div className="col-md-8">
                                        <div className="row gol_field_div">
                                            <div className="col-md-4  text-left">
                                                <div className="">
                                                    <span className="form-attribute">
                                                        {!this.props.viewIdea ? <><span style={{ color: 'red' }}>* </span> </> : null}
                                                        Monetizable Status
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="col-md-5 text-left">
                                                {

                                                    this.props.viewIdea
                                                        ?
                                                        <>
                                                            <input disabled value={this.state.monetizationStatusSelectedOption?.label} className="form-input disabled_input" />

                                                        </>
                                                        :
                                                        <Select 
                                                            options={MONETIZATIONOPTIONS}
                                                            onChange={(e)=>this.handleMonetizableStatusChange(e)}
                                                            value={this.state.monetizationStatusSelectedOption}
                                                        />
                                                }

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </>
                        :
                        null
                }

                {
                    this.state.impactOptionSelected?.label !== NO_VD &&
                        this.state.monetizableProjectSelectedOption?.label === "Yes" && 
                        this.state.monetizationStatusSelectedOption?.label === "Approved by Client"
                        ?
                        <>
                            <div className="monetization_client_fields">
                                <p className="u-align-left u-text u-text-2">Monetization Client Approval Details</p>
                                <div className="monetization_client_field_block">
                                    <div className="row u-align-left">
                                        <div className="col-md-5">
                                            {
                                                this.props.postFpnaValid
                                                    ?
                                                    <>
                                                        <div className="monetization_client_field">
                                                            <div className="row gol_field_div">
                                                                <div className="col-md-6 ">
                                                                    <div className="">
                                                                        <span className="form-attribute">
                                                                            {!this.props.viewIdea ? <><span style={{ color: 'red' }}>* </span> </> : null}
                                                                            GOL OHR for Monetization
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-6">
                                                                    {
                                                                        this.props.viewIdea
                                                                            ?
                                                                            <>
                                                                                {
                                                                                    this.state.GOLOHRMonetization
                                                                                        ?
                                                                                        <>
                                                                                            <input disabled value={this.state.GOLOHRMonetization} className="form-input disabled_input" />
                                                                                        </>
                                                                                        :
                                                                                        <input disabled className="form-input disabled_input" />
                                                                                }

                                                                            </>
                                                                            :
                                                                            <input pattern="\d*" maxLength="9"
                                                                                onCut={(e) => this.handleGOLOhrMonetizationOnCut(e)}
                                                                                onChange={(e) => this.handleGOLOhrMonetizationChange(e)}
                                                                                className="textarea-css form-attribute hide_numeric_arrows" type="number"
                                                                                defaultValue={this.state.GOLOHRMonetization}
                                                                                onKeyDown={(evt) => (evt.key === '.' || evt.key === 'e' || evt.key === 'E' || evt.key === '+' || evt.key === '-') && evt.preventDefault()}
                                                                                onWheel={(e) => e.target.blur()}
                                                                            />
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="monetization_client_field">
                                                            <div className="row gol_field_div">
                                                                <div className="col-md-6 ">
                                                                    <div className="">
                                                                        <span className="form-attribute">
                                                                            {!this.props.viewIdea ? <><span style={{ color: 'red' }}>* </span> </> : null}
                                                                            FP&A OHR for Monetization
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-6">
                                                                    {
                                                                        this.props.viewIdea
                                                                            ?
                                                                            <>
                                                                                {
                                                                                    this.state.FPnAOHRMonetization
                                                                                        ?
                                                                                        <>
                                                                                            <input disabled value={this.state.FPnAOHRMonetization} className="form-input disabled_input" />
                                                                                        </>
                                                                                        :
                                                                                        <input disabled className="form-input disabled_input" />

                                                                                }
                                                                            </>
                                                                            :
                                                                            <input pattern="\d*" maxLength="9"
                                                                                onChange={(e) => this.handleFpnaOhrMonetizationChange(e)}
                                                                                onCut={(e) => this.handleFpnaOhrMonetizationOnCut(e)}
                                                                                className="textarea-css form-attribute hide_numeric_arrows" type="number"
                                                                                defaultValue={this.state.FPnAOHRMonetization}
                                                                                onKeyDown={(evt) => (evt.key === '.' || evt.key === 'e' || evt.key === 'E' || evt.key === '+' || evt.key === '-') && evt.preventDefault()}
                                                                                onWheel={(e) => e.target.blur()}
                                                                            />
                                                                    }

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </>
                                                    :
                                                    null
                                            }

                                            <div className="monetization_client_field">
                                                <div className="row gol_field_div">
                                                    <div className="col-md-6 ">
                                                        <div className="">
                                                            <span className="form-attribute">
                                                                {!this.props.viewIdea ? <><span style={{ color: 'red' }}>* </span> </> : null}
                                                                SOW ID/SFDC/OLI ID
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        {
                                                            this.props.viewIdea
                                                                ?
                                                                <>
                                                                    <input 
                                                                        value={this.state.SowID ? this.state.SowID : ""} 
                                                                        className="form-input disabled_input" 
                                                                        disabled 
                                                                    />
                                                                </>
                                                                :
                                                                <input 
                                                                    value={this.state.SowID} 
                                                                    onChange={(e) => this.handleSowIdChange(e.target.value)}
                                                                    className="textarea-css form-attribute"
                                                                    type="text"
                                                                />

                                                        }

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-2"></div>
                                        <div className="col-md-5">
                                            {
                                                this.props.postFpnaValid
                                                    ?
                                                    <>
                                                        <div className="monetization_client_field">
                                                            <div className="row gol_field_div">
                                                                <div className="col-md-5">
                                                                    <div className="">
                                                                        <span className="form-attribute">
                                                                            {!this.props.viewIdea ? <><span style={{ color: 'red' }}>* </span> </> : null}
                                                                            GOL Name for Monetization
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-7">
                                                                    <input disabled className="form-input disabled_input" type="text" value={this.state.GOLNameMonetization} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="monetization_client_field">
                                                            <div className="row gol_field_div">
                                                                <div className="col-md-5">
                                                                    <div className="">
                                                                        <span className="form-attribute">
                                                                            {!this.props.viewIdea ? <><span style={{ color: 'red' }}>* </span> </> : null}
                                                                            FP&A Name for Monetization
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-7">
                                                                    <input disabled className="form-input disabled_input" type="text" value={this.state.FPnANameMonetization} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </>
                                                    :
                                                    null
                                            }

                                        </div>
                                    </div>
                                    <div className="">
                                        <div className="row u-align-left">
                                            <div className="col-md-6">
                                                {
                                                    this.props.postFpnaValid
                                                        ?
                                                        <>
                                                            <div className="">
                                                                <div className="row">
                                                                    <div className="col-md-6">
                                                                        <label>
                                                                            {!this.props.viewIdea ? <><span style={{ color: 'red' }}>* </span> </> : null}
                                                                            FP&A Sign-off Document
                                                                            <small style={{ color: "#939393", fontSize: "12px" }}>&nbsp;(Max Size: 5MB)</small>
                                                                        </label>
                                                                    </div>
                                                                    <div className="col-md-4">
                                                                        {
                                                                            !this.props.viewIdea
                                                                                ?
                                                                                <>

                                                                                    <label htmlFor="file-upload2" className="u-active-custom-color-6 u-border-2 u-border-active-black u-border-hover-black u-border-white u-btn u-btn-round u-button-style u-custom-color-3 u-hover-custom-color-6 u-radius-6 u-btn-2">&nbsp;&nbsp;+&nbsp;&nbsp;</label>
                                                                                    <input id="file-upload2"
                                                                                        type="file" style={{ display: 'none' }}
                                                                                        onChange={(event) => this.myFIleChange(event, "file1")}
                                                                                        accept=".xls,.xlsx,.xlsm,.csv,.doc,.docx,.pdf,.pptx,.jpeg,.jpg,.png,.msg,.mpp,image/jpeg,image/png,application/pdf,application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, text/csv, application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.presentationml.presentation,application/msproject,application/vnd.ms-outlook"
                                                                                    />
                                                                                </>
                                                                                :
                                                                                null
                                                                        }

                                                                    </div>
                                                                </div>
                                                                <div className="row">
                                                                    <div className="col-md-10">
                                                                        <label className={this.state.FPnAFileNameMonetization && this.state.FPnAFileNameMonetization.length > 50 ? "upload_file_text_overflow" : ""} style={{ cursor: "pointer", color: "#337ab7", fontWeight: "bold" }} onClick={(e) => this.showMonetizationContent()}><i>&nbsp;&nbsp;{this.state.FPnAFileNameMonetization}</i></label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </>
                                                        :
                                                        null
                                                }

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                        :
                        null
                }
                {/* ..................monetization client approval process ends here.......... */}


                {/* ...........monetization amount starts here......... */}

                {
                    this.state.monetizationStatusSelectedOption && this.state.impactOptionSelected && this.state.impactOptionSelected.label !== NO_VD
                        ?
                        <>
                            <div className="total_monetized_amount_block">
                                <p id="BI Summary" className="u-align-left u-text u-text-2">Total Monetized Amount</p>
                                <div className="row mt-3" style={{ marginLeft: 0, marginRight: 0 }}>
                                    <div className="col-md-2 col-xs-12 total_monetizable_header">
                                        <label >FTE Impact (#)</label>
                                    </div>
                                    <div className="col-md-3 col-xs-6 total_monetizable_header">
                                        <label>$ Impact</label>
                                    </div>
                                </div>
                                <div className="row total_monetizable_data_row">
                                    <div className="col-md-2 col-xs-12 borderClass">
                                        <label >
                                            {isNaN(this.state.totalMonetizedFTE) ? 0 : this.state.totalMonetizedFTE}
                                        </label>
                                    </div>
                                    <div className="col-md-3 col-xs-6 borderClass">
                                        <label>
                                            {isNaN(this.state.totalMonetizedDollar) ? 0 : this.state.totalMonetizedDollar}
                                        </label>
                                    </div>
                                </div>

                            </div>
                        </>
                        :
                        null
                }

                {/* ...........monetization amount ends here......... */}


                <div className="BI_component ">
                    {
                        this.state.impactOptionSelected
                            ?
                            <>
                                <div className="final_additional_block">
                                    <h3 className="idea_form_header">Business additional details</h3>
                                    <div className="row">
                                        <div className="col-md-5">
                                            <div className="">
                                                <div className="final_additional_block_field">
                                                    <div className="row">
                                                        <div className="col-md-5">
                                                            <label className="form-attribute">Final Impact (# of FTE)</label>
                                                        </div>
                                                        <div className="col-md-7">
                                                            <input className="form-input" disabled name="finalimpactFTE"
                                                                value={this.state.impactOptionSelected && this.state.impactOptionSelected.label === NO_VD ? 0 : this.state.finalImpactFTE}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="final_additional_block_field">
                                                    <div className="row">
                                                        <div className="col-md-5">
                                                            <label className="form-attribute">Final Impact ($)</label>
                                                        </div>
                                                        <div className="col-md-7">
                                                            <input className="form-input" disabled name="finalimpactdollar"
                                                                value={this.state.impactOptionSelected && this.state.impactOptionSelected.label === NO_VD ? 0 : this.state.finalImpactDollar}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>


                                            </div>
                                        </div>
                                        <div className="col-md-2"></div>
                                        <div className="col-md-5">
                                            <div className="final_additional_block_field">
                                                <div className="row">
                                                    <div className="col-md-5">
                                                        <label className="form-attribute">Is it a Zero Impact Project</label>
                                                    </div>
                                                    <div className="col-md-7">
                                                        <label className="switch">
                                                            <input 
                                                                disabled 
                                                                type="checkbox" 
                                                                checked={this.state.impactOptionSelected?.label !== NO_VD ? false : true} 
                                                            />
                                                            <span className="slider round not_allowed_curoser" />
                                                        </label>
                                                        
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="final_additional_block_field">
                                                {
                                                    this.state.impactOptionSelected && this.state.impactOptionSelected.label !== NO_VD
                                                        ?
                                                        <>
                                                            <p>If Final Impact $ is greater than 250K OR FTE number is greater than 10, please review thoroughly</p>
                                                        </>
                                                        :
                                                        null
                                                }

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                            :
                            null
                    }


                    {
                        this.state.impactOptionSelected && this.state.impactOptionSelected.label !== NO_VD
                            ?
                            <>
                                <div className=" VD_Summary idea_common_block pb-5">
                                    <h3 className="idea_form_header">Value Delivery Summary</h3>
                                    <div className="row mt-3">
                                        <div className="col-md-2 col-xs-12 VD_Summary_table_header">
                                            <div className="">
                                                <label>Impact Type</label>
                                            </div>
                                        </div>
                                        <div className="col-md-3 col-xs-6 VD_Summary_table_header">
                                            <div className="">
                                                <label>Category</label>
                                            </div>
                                        </div>
                                        <div className="col-md-2 col-xs-6 text-center VD_Summary_table_header">
                                            <div className="">
                                                <label>FTE Impact (#)</label>
                                            </div>
                                        </div>
                                        <div className="col-md-2 col-xs-6 text-center VD_Summary_table_header">
                                            <div className="">
                                                <label>$ Impact</label>
                                            </div>
                                        </div>
                                    </div>
                                    {this.state.summaryArray.length > 0 && this.state.summaryArray.map((currItem, index) => {
                                        return (
                                            <>
                                                <div className="">
                                                    <div className="row">
                                                        <div className="col-md-2 col-xs-12 VD_Summary_table_row">
                                                            <div className="">
                                                                <label>{currItem.ImpactType}</label>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3 col-xs-6 VD_Summary_table_row">
                                                            <div className="">
                                                                <label>{currItem.MonetizableType}</label>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-2 col-xs-6 text-center VD_Summary_table_row">
                                                            <div className="">
                                                                <label>{isNaN(currItem.FTEImpact) ? 0 : currItem.FTEImpact}</label>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-2 col-xs-6 text-center VD_Summary_table_row">
                                                            <div className="">
                                                                <label>{isNaN(currItem.DollarImpact) ? 0 : currItem.DollarImpact}</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </>
                                        )
                                    })}
                                </div>
                                <div className="VD_form idea_common_block_last_block">
                                    <div className="">
                                        <h3 className="idea_form_header">Value Delivery Form</h3>
                                        {
                                            this.props.viewIdea === false
                                                ?
                                                <>
                                                    <div className="row d_flex_align_items_center">
                                                        <div className="col-md-3">
                                                            <div className="">
                                                                <div className="row">
                                                                    <div className="col-md-1" style={{ paddingRight: "0px" }}>
                                                                        <span className="form-attribute cursorClass" title="Select Impact Type">
                                                                            <span style={{ color: 'red' }}>*</span>
                                                                        </span>
                                                                    </div>
                                                                    <div className="col-md-10" style={{ paddingLeft: "5px" }}>
                                                                        <Select 
                                                                            options={this.renderFilteredImpactType()}
                                                                            isSearchable={false} 
                                                                            placeholder="Select Impact type"
                                                                            onChange={(e)=>this.handleImpactTypeChange(e)}
                                                                            value={this.state.filteredImpactTypeSelectedOption}
                                                                            isDisabled={this.props.bbMonetizationApproval && this.state.monetizationStatusSelectedOption && this.state.monetizationStatusSelectedOption.label !== "Approved by Client" ? true : false}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <div className="">
                                                                <div className="row">
                                                                    <div className="col-md-1" style={{ paddingRight: "0px" }}>
                                                                        <span className="form-attribute cursorClass" title="Select category">
                                                                            <span style={{ color: 'red' }}>*</span>
                                                                        </span>
                                                                    </div>
                                                                    <div className="col-md-10" style={{ paddingLeft: "0px" }}>
                                                                        <Select 
                                                                            options={this.renderFilteredMonetizableType()} 
                                                                            isSearchable={false}
                                                                            placeholder="Select Category" 
                                                                            onChange={this.handleMonetizableTypeChange}
                                                                            value={this.state.filteredMonetizableSelectedOption}
                                                                            isDisabled={this.props.bbMonetizationApproval && this.state.monetizationStatusSelectedOption && this.state.monetizationStatusSelectedOption.label !== "Approved by Client" ? true : false}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="col-md-4">
                                                            <div className="">
                                                                <div className="row">
                                                                    <div className="col-md-1" style={{ paddingRight: "0px" }}>
                                                                        <span className="form-attribute cursorClass" title="Select sub category">
                                                                            <span style={{ color: 'red' }}>*</span>
                                                                        </span>
                                                                    </div>
                                                                    <div className="col-md-10" style={{ paddingLeft: "0px" }}>
                                                                        <Select 
                                                                            options={this.renderFilteredBiSubCategoryType()} 
                                                                            isSearchable={false}
                                                                            value={this.state.filteredBISubCategorySelectedOption}
                                                                            placeholder="Select Sub Category" 
                                                                            onChange={this.handleBiSubCategoryChange}
                                                                            isDisabled={this.props.bbMonetizationApproval && this.state.monetizationStatusSelectedOption && this.state.monetizationStatusSelectedOption.label !== "Approved by Client" ? true : false}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-1">
                                                            <div className="">
                                                                <button className="u-active-custom-color-6 u-border-2 u-border-active-black u-border-hover-black u-border-white u-btn u-btn-round u-button-style u-custom-color-3 u-hover-custom-color-6 u-radius-6 u-btn-3" onClick={(e) => this.addSelectedValues(e, this.state.monetizedAlertCounter)}
                                                                    disabled={this.props.bbMonetizationApproval && this.state.monetizationStatusSelectedOption && this.state.monetizationStatusSelectedOption.label !== "Approved by Client" ? true : false}
                                                                >Add</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                                :
                                                null
                                        }

                                    </div>
                                    <div className="bi_summary_latest">
                                        <div className="row mt-4" style={{ marginLeft: 10, marginRight: 10, justifyContent: "center" }}>
                                            {
                                                this.props.viewIdea === false
                                                    ?
                                                    <>
                                                        <div className="col-md-2 col-xs-12 bi_summary_latest_header_div">
                                                            <label>Impact Type</label>
                                                        </div>
                                                        <div className="col-md-2 col-xs-12 bi_summary_latest_header_div ">
                                                            <label>Category</label>
                                                        </div>
                                                        <div className="col-md-3 col-xs-12 bi_summary_latest_header_div ">
                                                            <label>Sub Category</label>
                                                        </div>
                                                        <div className="col-md-1 col-xs-12 bi_summary_latest_header_div">
                                                            <label>FTE Impact (#)</label>
                                                        </div>
                                                        <div className="col-md-2 col-xs-12 bi_summary_latest_header_div">
                                                            <label>$ Impact</label>
                                                        </div>
                                                        <div className="col-md-1 col-xs-12 bi_summary_latest_header_div">
                                                            <label>Monetized</label>
                                                        </div>
                                                        <div className="col-md-1 col-xs-12 bi_summary_latest_header_div">
                                                            <label></label>
                                                        </div>

                                                    </>
                                                    :
                                                    <>
                                                        <div className="col-md-2 col-xs-12 bi_summary_latest_header_div">
                                                            <label>Impact Type</label>
                                                        </div>
                                                        <div className="col-md-2 col-xs-12 bi_summary_latest_header_div ">
                                                            <label>Category</label>
                                                        </div>
                                                        <div className="col-md-3 col-xs-12 bi_summary_latest_header_div ">
                                                            <label>Sub Category</label>
                                                        </div>
                                                        <div className="col-md-2 col-xs-12 bi_summary_latest_header_div">
                                                            <label>FTE Impact (#)</label>
                                                        </div>
                                                        <div className="col-md-2 col-xs-12 bi_summary_latest_header_div">
                                                            <label>$ Impact</label>
                                                        </div>
                                                        <div className="col-md-1 col-xs-12 bi_summary_latest_header_div">
                                                            <label>Monetized</label>
                                                        </div>

                                                    </>
                                            }
                                        </div>
                                        {
                                            this.props.viewIdea
                                                ?
                                                <>
                                                    {
                                                        this.state.businessImpactValueArray.map((item, index) => {
                                                            return (
                                                                <div key={item.SrNo} className="row" style={{ marginLeft: 10, marginRight: 10, justifyContent: "center" }}>
                                                                    <div className="col-md-2 col-xs-12 bi_summary_latest_body_text_elements bi_cell_height">
                                                                        <label>{item.ImpactType}</label>
                                                                    </div>
                                                                    <div className="col-md-2 col-xs-12 bi_summary_latest_body_text_elements bi_cell_height">
                                                                        <label>{item.MonetizableType}</label>
                                                                    </div>
                                                                    <div className="col-md-3 col-xs-12 bi_summary_latest_body_text_elements bi_cell_height">
                                                                        <label>{item.BISubCategory}</label>
                                                                    </div>
                                                                    <div className="col-md-2 col-xs-12 bi_summary_latest_body_text_elements bi_cell_height">
                                                                        {
                                                                            (item.FTEImpact > 0.0)
                                                                                ?
                                                                                <>
                                                                                    <input className="form-input" disabled type="number" value={item.FTEImpact} />
                                                                                </>
                                                                                :
                                                                                null
                                                                        }
                                                                    </div>
                                                                    <div className="col-md-2 col-xs-12 bi_summary_latest_body_text_elements bi_cell_height">
                                                                        <input className="form-input" type="number" disabled min="0" max="500000000" defaultValue={item.DollarImpact} placeholder={0.0} />
                                                                    </div>
                                                                    <div className="col-md-1 col-xs-12 bi_summary_latest_body_text_elements bi_cell_height">
                                                                        <input type="checkbox" checked={item.IsMonetized === "Yes" ? true : false} style={{ cursor: "no-drop" }} />
                                                                    </div>
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </>
                                                :
                                                <>
                                                    {
                                                        this.state.businessImpactValueArray.map((item, index) => {
                                                            // console.log('business impact value array at vd function=>',this.state.businessImpactValueArray)
                                                            const isFtePresent = this.checkIsFtePresent(item);
                                                            return (
                                                                <div key={item.SrNo} className="row" style={{ marginLeft: 10, marginRight: 10, justifyContent: "center" }}>
                                                                    <div className="col-md-2 col-xs-12 bi_summary_latest_body_text_elements bi_cell_height">
                                                                        <label>{item.ImpactType}</label>
                                                                    </div>
                                                                    <div className="col-md-2 col-xs-12 bi_summary_latest_body_text_elements bi_cell_height">
                                                                        <label>{item.MonetizableType}</label>
                                                                    </div>
                                                                    <div className="col-md-3 col-xs-12 bi_summary_latest_body_text_elements bi_cell_height">
                                                                        <label>{item.BISubCategory}</label>
                                                                    </div>
                                                                    <div className="col-md-1 col-xs-12 bi_summary_latest_body_text_elements bi_cell_height">

                                                                        
                                                                        
                                                                        {
                                                                            
                                                                            isFtePresent && (
                                                                                <>
                                                                                    {
                                                                                        this.props.bbMonetizationApproval
                                                                                            ?
                                                                                            <>
                                                                                                {
                                                                                                    
                                                                                                    item.ImpactType === IMPACT_TO_GENPACT && item.MonetizableType === "Increase in Revenue" && this.state.monetizationStatusSelectedOption.label === "Approved by Client" && item.IsMonetized === "Yes"
                                                                                                        ?
                                                                                                        <>
                                                                                                            <input 
                                                                                                                type="number" 
                                                                                                                min="0" 
                                                                                                                style={{ border: '1px solid lightgrey' }}
                                                                                                                placeholder={0} max={199}
                                                                                                                onBlur={(event) => this.handleBIFTEChange(item.ImpactType, item.MonetizableType, item.BISubCategory, event.target.value, index, event, isFtePresent,item.SrNo,item)}
                                                                                                                defaultValue={item.FTEImpact}
                                                                                                                className="bi-component-form-input"
                                                                                                                disabled={false}
                                                                                                                onWheel={(e) => e.target.blur()}
                                                                                                            />
                                                                                                        </>
                                                                                                        :
                                                                                                        <input 
                                                                                                            type="number" 
                                                                                                            min="0" 
                                                                                                            style={{ border: '1px solid lightgrey' }}
                                                                                                            placeholder={0} max={199}
                                                                                                            onBlur={(event) => this.handleBIFTEChange(item.ImpactType, item.MonetizableType, item.BISubCategory, event.target.value, index, event, isFtePresent,item.SrNo,item)}
                                                                                                            defaultValue={item.FTEImpact}
                                                                                                            className="bi-component-form-input bi-component-disabled-form-input"
                                                                                                            disabled={true}
                                                                                                            onWheel={(e) => e.target.blur()}
                                                                                                        />
                                                                                                }
                                                                                            </>
                                                                                            :
                                                                                            <input 
                                                                                                type="number" 
                                                                                                min="0" 
                                                                                                style={{ border: '1px solid lightgrey' }}
                                                                                                placeholder={0} max={199}
                                                                                                onBlur={(event) => this.handleBIFTEChange(item.ImpactType, item.MonetizableType, item.BISubCategory, event.target.value, index, event, isFtePresent,item.SrNo,item)}
                                                                                                defaultValue={item.FTEImpact}
                                                                                                className="bi-component-form-input"
                                                                                                disabled={false}
                                                                                                onWheel={(e) => e.target.blur()}
                                                                                            />
                                                                                    }

                                                                                </>
                                                                            )
                                                                        }

                                                                    </div>
                                                                    <div className="col-md-2 col-xs-12 bi_summary_latest_body_text_elements bi_cell_height">
                                                                        {
                                                                            this.props.bbMonetizationApproval
                                                                                ?
                                                                                <>
                                                                                    {
                                                                                        item.ImpactType === IMPACT_TO_GENPACT && item.MonetizableType === "Increase in Revenue" && this.state.monetizationStatusSelectedOption.label === "Approved by Client" && item.IsMonetized === "Yes"
                                                                                            ?
                                                                                            <>
                                                                                                <input 
                                                                                                    type="number" 
                                                                                                    min="0" 
                                                                                                    max="500000000"
                                                                                                    style={{ border: '1px solid lightgrey' }}
                                                                                                    placeholder={0.0}
                                                                                                    onBlur={(event) => this.handleBIDollarChange(item.ImpactType, item.SrNo, item.MonetizableType, item.BISubCategory, event.target.value, index, event, isFtePresent)}
                                                                                                    defaultValue={item.DollarImpact}
                                                                                                    className="bi-component-form-input"
                                                                                                    disabled={false}
                                                                                                    onWheel={(e) => e.target.blur()}
                                                                                                />
                                                                                            </>
                                                                                            :
                                                                                            <input 
                                                                                                type="number" 
                                                                                                min="0" 
                                                                                                max="500000000"
                                                                                                style={{ border: '1px solid lightgrey' }}
                                                                                                placeholder={0.0}
                                                                                                onBlur={(event) => this.handleBIDollarChange(item.ImpactType, item.SrNo, item.MonetizableType, item.BISubCategory, event.target.value, index, event, isFtePresent)}
                                                                                                defaultValue={item.DollarImpact}
                                                                                                className="bi-component-form-input bi-component-disabled-form-input"
                                                                                                disabled={true}
                                                                                                onWheel={(e) => e.target.blur()}
                                                                                            />

                                                                                    }
                                                                                </>
                                                                                :
                                                                                <input 
                                                                                    type="number" 
                                                                                    min="0" 
                                                                                    max="500000000"
                                                                                    style={{ border: '1px solid lightgrey' }}
                                                                                    placeholder={0.0}
                                                                                    onBlur={(event) => this.handleBIDollarChange(item.ImpactType, item.SrNo, item.MonetizableType, item.BISubCategory, event.target.value, index, event, isFtePresent)}
                                                                                    defaultValue={item.DollarImpact}
                                                                                    className="bi-component-form-input"
                                                                                    disabled={false}
                                                                                    onWheel={(e) => e.target.blur()}
                                                                                />
                                                                        }
                                                                    </div>
                                                                    <div className="col-md-1 col-xs-12 bi_summary_latest_body_text_elements bi_cell_height">
                                                                        {
                                                                            this.props.bbMonetizationApproval
                                                                                ?
                                                                                <>
                                                                                    {
                                                                                        item.ImpactType === IMPACT_TO_GENPACT && (item.MonetizableType === "Increase in Revenue" || (item.BISubCategory === "FTE Equivalent - Increase in Billable Hours" || item.BISubCategory === "FTE Equivalent - Improvement in Transaction Based Billing")) ?
                                                                                            <>
                                                                                                <input type="checkbox" checked={true} readOnly={true} style={{ cursor: "no-drop" }} />
                                                                                            </>
                                                                                            :
                                                                                            <input disabled={true} type="checkbox" style={{ cursor: "no-drop" }} />
                                                                                    }
                                                                                </>
                                                                                :
                                                                                <>
                                                                                    {
                                                                                        item.ImpactType === IMPACT_TO_GENPACT && (item.MonetizableType === "Increase in Revenue" || (item.BISubCategory === "FTE Equivalent - Increase in Billable Hours" || item.BISubCategory === "FTE Equivalent - Improvement in Transaction Based Billing")) ?
                                                                                            <>
                                                                                                <input type="checkbox" checked={true} readOnly={true} style={{ cursor: "no-drop" }} />
                                                                                            </>
                                                                                            :
                                                                                            <input disabled={true} type="checkbox" style={{ cursor: "no-drop" }} />
                                                                                    }
                                                                                </>

                                                                        }
                                                                    </div>
                                                                    <div className="col-md-1 col-xs-12 bi_summary_latest_body_text_elements bi_cell_height">
                                                                        {
                                                                            this.props.bbMonetizationApproval
                                                                                ?
                                                                                <>
                                                                                    {
                                                                                        item.ImpactType === IMPACT_TO_GENPACT && item.MonetizableType === "Increase in Revenue" && this.state.monetizationStatusSelectedOption.label === "Approved by Client" && item.IsMonetized === "Yes"
                                                                                            ?
                                                                                            <>
                                                                                                <button onClick={() => this.removeBiFormRow(index, item)}
                                                                                                    disabled={false}
                                                                                                    className="u-active-custom-color-6 u-border-2 u-border-active-black u-border-hover-black u-border-white u-btn u-btn-round u-button-style u-custom-color-3 u-hover-custom-color-6 u-radius-6 u-btn-2" style={{ marginTop: "13px", padding: "2px 3px" }}>&nbsp;&nbsp;<i className="fa fa-trash" aria-hidden="true" /> &nbsp;Delete&nbsp;&nbsp;
                                                                                                </button>
                                                                                            </>
                                                                                            :
                                                                                            <button onClick={() => this.removeBiFormRow(index, item)}
                                                                                                disabled={true}
                                                                                                className="u-active-custom-color-6 u-border-2 u-border-active-black u-border-hover-black u-border-white u-btn u-btn-round u-button-style u-custom-color-3 u-hover-custom-color-6 u-radius-6 u-btn-2" style={{ marginTop: "13px", padding: "2px 3px" }}>&nbsp;&nbsp;<i className="fa fa-trash" aria-hidden="true" /> &nbsp;Delete&nbsp;&nbsp;
                                                                                            </button>

                                                                                    }
                                                                                </>
                                                                                :
                                                                                <button onClick={() => this.removeBiFormRow(index, item)}
                                                                                    disabled={false}
                                                                                    className="u-active-custom-color-6 u-border-2 u-border-active-black u-border-hover-black u-border-white u-btn u-btn-round u-button-style u-custom-color-3 u-hover-custom-color-6 u-radius-6 u-btn-2" style={{ marginTop: "13px", padding: "2px 3px" }}>&nbsp;&nbsp;<i className="fa fa-trash" aria-hidden="true" /> &nbsp;Delete&nbsp;&nbsp;
                                                                                </button>

                                                                        }
                                                                    </div>


                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </>
                                        }

                                    </div>
                                </div>
                            </>
                            :
                            null
                    }
                </div>
            </div>
        )

    }




}

export default ValueDelivery




